var snapshot =
webpackJsonp_name_([2],{

/***/ 10:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(71);


/***/ }),

/***/ 11:
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1,eval)("this");
} catch(e) {
	// This works if the window reference is available
	if(typeof window === "object")
		g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),

/***/ 136:
/***/ (function(module, exports) {

module.exports = {
	"toolbar-icon-alt-text": "Capture a snapshot image.",
	"settings-icon-alt-text": "Open snapshot settings.",
	"snapshot-settings": "Snapshot Settings",
	"image-settings": "Image Settings",
	"select-mode": "Capture Mode",
	"full-view": "Full View",
	"full-view-description": "Captures your current view.",
	"fixed-size": "Fixed Size",
	"fixed-size-description": "Captures an area of the width and height you specified.",
	"resizable": "User Drawn",
	"resizable-description": "Captures an area that you select.",
	"settings": "Settings",
	"width": "Width",
	"height": "Height",
	"px": "px",
	"capture": "Capture",
	"advanced-settings": "Advanced Settings",
	"save-to": "Save To",
	"local": "My Downloads Folder",
	"local-description": "Snapshot image is saved to your computer's Downloads folder.",
	"remote": "Custom Integration",
	"remote-description": "Only for use with custom integrations. Snapshot image is saved as configured by your System Administrator.",
	"description": "Description",
	"notices": {
		"success": "Snapshot downloaded!",
		"download-failed": "Could not download snapshot. Sorry about that. Maybe try again in a few moments?",
		"create-failed": "Could not create snapshot. Sorry about that. Maybe try again in a few moments?"
	}
};

/***/ }),

/***/ 137:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.RoiHandlerBase = undefined;

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(2);

var _createClass3 = _interopRequireDefault(_createClass2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * A Base class for capturing a region of interest from user input.
 */
var RoiHandlerBase = exports.RoiHandlerBase = function () {
    function RoiHandlerBase(eventChannel, viewport, settings) {
        (0, _classCallCheck3.default)(this, RoiHandlerBase);

        this.settings = Object.assign({
            viewportInfo: viewport.getVPView()
        }, settings);
        this.eventChannel = eventChannel;
    }

    (0, _createClass3.default)(RoiHandlerBase, [{
        key: 'signalUserActionComplete',
        value: function signalUserActionComplete(drawing) {
            this.eventChannel.trigger('drawing:user-action-complete', drawing);
        }
    }, {
        key: 'finish',
        value: function finish(drawing, zoom) {
            this.eventChannel.trigger('drawing:complete', drawing, zoom || this.settings.viewportInfo.zoom);
        }

        /**
         * Normalize the rectangle's coordinate system to the viewport's.
         * @param rectangle
         * @param viewportInfo
         */

    }], [{
        key: 'normalizeAndOffset',
        value: function normalizeAndOffset(rectangle, viewportInfo) {
            var vpOffset = {
                x: viewportInfo.left / viewportInfo.zoom,
                y: viewportInfo.top / viewportInfo.zoom
            };
            rectangle.offset(vpOffset.x, vpOffset.y).normalize();
        }
    }]);
    return RoiHandlerBase;
}();

/***/ }),

/***/ 138:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.ClearRectangle = undefined;

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(2);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(21);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(20);

var _inherits3 = _interopRequireDefault(_inherits2);

var _BaseRectangle2 = __webpack_require__(305);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DEFAULT_OPTIONS = {
    border: {
        lineWidth: '1',
        color: 'red'
    }
};

/**
 * This clears a rectangle-shaped area on a canvas. Useful for emptying part of a canvas (e.g. with a background).
 */

var ClearRectangle = exports.ClearRectangle = function (_BaseRectangle) {
    (0, _inherits3.default)(ClearRectangle, _BaseRectangle);

    function ClearRectangle(x, y, w, h) {
        var options = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : DEFAULT_OPTIONS;
        (0, _classCallCheck3.default)(this, ClearRectangle);
        return (0, _possibleConstructorReturn3.default)(this, (ClearRectangle.__proto__ || Object.getPrototypeOf(ClearRectangle)).call(this, x, y, w, h, options));
    }

    (0, _createClass3.default)(ClearRectangle, [{
        key: 'paint',
        value: function paint(ctx, x, y, w, h) {
            ctx.clearRect(x, y, w, h);

            if (this._options.border) {
                ctx.beginPath();
                ctx.lineWidth = this._options.border.lineWidth;
                ctx.strokeStyle = this._options.border.color;
                ctx.rect(x, y, w, h);
                ctx.stroke();
            }
        }
    }]);
    return ClearRectangle;
}(_BaseRectangle2.BaseRectangle);

/***/ }),

/***/ 146:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

__webpack_require__(171);

var draggable = {
    methods: {
        setDragTarget: function setDragTarget(el, elContext) {
            this.__dragTarget__ = el;
            this.__dragTarget__.className += ' draggable';
            this.__dragTarget__.addEventListener('mousedown', this.__dragInit__);
            // only needed outside vue
            if (elContext) {
                this.$el = elContext;
            }
        },
        __dragInit__: function __dragInit__(e) {
            this.__dragOrigin__ = {
                // If the control tells us where the element is, trust it. Fallback to browser. Note that browser
                // reports elements position relative to the document, which isn't reliable if the element is positioned
                // relative to some other element.
                element: this.getPosition ? this.getPosition() : this.$el.getBoundingClientRect(),
                mouse: {
                    x: e.clientX,
                    y: e.clientY
                }
            };

            document.addEventListener('mouseup', this.__dragEnd__);
            // Oddly, throttling this appears to make performance worse, in all browsers.
            document.addEventListener('mousemove', this.__drag__);
            return false;
        },
        __drag__: function __drag__(e) {
            var dragOffset = {
                x: this.__dragOrigin__.mouse.x - e.clientX,
                y: this.__dragOrigin__.mouse.y - e.clientY
            };
            this.moveTo({
                left: this.__dragOrigin__.element.left - dragOffset.x + 'px',
                top: this.__dragOrigin__.element.top - dragOffset.y + 'px'
            });
            return false;
        },
        __dragEnd__: function __dragEnd__() {
            delete this.__dragOrigin__;
            document.removeEventListener('mouseup', this.__dragEnd__);
            document.removeEventListener('mousemove', this.__drag__);
            return false;
        }
    }
};

exports.default = draggable;
module.exports = exports['default'];

/***/ }),

/***/ 158:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.AnnotationsReaderBase = undefined;

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(2);

var _createClass3 = _interopRequireDefault(_createClass2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AnnotationsReaderBase = exports.AnnotationsReaderBase = function () {
    function AnnotationsReaderBase(annotationsHelper) {
        (0, _classCallCheck3.default)(this, AnnotationsReaderBase);

        Object.defineProperties(this, {
            _annotationsHelper: { value: annotationsHelper }
        });
    }

    (0, _createClass3.default)(AnnotationsReaderBase, [{
        key: "capture",
        value: function capture(viewport, rectangle, zoom) {
            if (this._capture) {
                var _annotationsHelper$ge = this._annotationsHelper.getSvgData(viewport, rectangle, zoom),
                    content = _annotationsHelper$ge.content,
                    meta = _annotationsHelper$ge.meta;

                return this._capture(content, meta);
            }
        }
    }, {
        key: "render",
        value: function render(context) {}
    }, {
        key: "cleanup",
        value: function cleanup() {}
    }]);
    return AnnotationsReaderBase;
}();

/***/ }),

/***/ 171:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 18:
/***/ (function(module, exports) {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


/***/ }),

/***/ 25:
/***/ (function(module, exports, __webpack_require__) {

var ctx                = __webpack_require__(19)
  , invoke             = __webpack_require__(54)
  , html               = __webpack_require__(103)
  , cel                = __webpack_require__(83)
  , global             = __webpack_require__(7)
  , process            = global.process
  , setTask            = global.setImmediate
  , clearTask          = global.clearImmediate
  , MessageChannel     = global.MessageChannel
  , counter            = 0
  , queue              = {}
  , ONREADYSTATECHANGE = 'onreadystatechange'
  , defer, channel, port;
var run = function(){
  var id = +this;
  if(queue.hasOwnProperty(id)){
    var fn = queue[id];
    delete queue[id];
    fn();
  }
};
var listener = function(event){
  run.call(event.data);
};
// Node.js 0.9+ & IE10+ has setImmediate, otherwise:
if(!setTask || !clearTask){
  setTask = function setImmediate(fn){
    var args = [], i = 1;
    while(arguments.length > i)args.push(arguments[i++]);
    queue[++counter] = function(){
      invoke(typeof fn == 'function' ? fn : Function(fn), args);
    };
    defer(counter);
    return counter;
  };
  clearTask = function clearImmediate(id){
    delete queue[id];
  };
  // Node.js 0.8-
  if(__webpack_require__(28)(process) == 'process'){
    defer = function(id){
      process.nextTick(ctx(run, id, 1));
    };
  // Browsers with MessageChannel, includes WebWorkers
  } else if(MessageChannel){
    channel = new MessageChannel;
    port    = channel.port2;
    channel.port1.onmessage = listener;
    defer = ctx(port.postMessage, port, 1);
  // Browsers with postMessage, skip WebWorkers
  // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
  } else if(global.addEventListener && typeof postMessage == 'function' && !global.importScripts){
    defer = function(id){
      global.postMessage(id + '', '*');
    };
    global.addEventListener('message', listener, false);
  // IE8-
  } else if(ONREADYSTATECHANGE in cel('script')){
    defer = function(id){
      html.appendChild(cel('script'))[ONREADYSTATECHANGE] = function(){
        html.removeChild(this);
        run.call(id);
      };
    };
  // Rest old browsers
  } else {
    defer = function(id){
      setTimeout(ctx(run, id, 1), 0);
    };
  }
}
module.exports = {
  set:   setTask,
  clear: clearTask
};

/***/ }),

/***/ 301:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.DrawingSurface = undefined;

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(2);

var _createClass3 = _interopRequireDefault(_createClass2);

var _lbsPiDash = __webpack_require__(5);

var _Point = __webpack_require__(107);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * The "Drawing surface" is a construct that manages the relationship between a canvas and the things that can be drawn on it. It's
 * expected to be used in conjunction with a "renderer" which will periodically call "draw()" on the surface.
 * This also provides an interface to allow consumers to specify mouse handlers. Only one set of mouse handlers can be active at a
 * time. This makes it simpler to manage conditions where we want to change the behavior of what happens when the user interacts
 * with the canvas. For instance, if we want to pan the background, we'd pass in a set of "pan handlers". If we wanted to zoom, we'd
 * pass in "zoom handlers". If we wanted to draw, well, you get the idea.
 */
var DrawingSurface = exports.DrawingSurface = function () {
    function DrawingSurface(canvas, offsetElement) {
        (0, _classCallCheck3.default)(this, DrawingSurface);

        offsetElement = offsetElement || canvas;
        var self = this;

        // Store the base position of the drawing surface.
        var position = new _Point.Point();

        // Store a reference to the canvas's drawing context.
        var ctx = canvas.getContext('2d');

        // Store information about the viewport's style (useful for calculations during the draw() cycle).
        var style = calculateStyleOffsets(offsetElement);

        // the collection of things to be drawn
        // const shapes = [];

        // Determines whether the canvas and the shapes on it need to be redrawn.
        this.valid = false;

        /**
         * Setup event listeners.
         */

        // Stores mouse handlers defined by the consumer.
        var activeMouseHandlers = {};
        var internalMouseHandlers = {
            selectStart: function selectStart(e) {
                e.preventDefault();
                return false;
            }
        };
        // Prevents a problem where double clicking causes text to get selected on the canvas
        canvas.addEventListener('selectstart', internalMouseHandlers.selectStart, false);

        // Add "handy" mouse handler wrapper function
        ['dblclick', 'mousedown', 'mouseup', 'mousemove'].forEach(function (action) {
            internalMouseHandlers[action] = function (e) {
                if (!activeMouseHandlers[action]) {
                    return;
                }

                var mouse = self.getMousePosition(e);
                var dragOffset = new _Point.Point(mouse.x - self.position.x, mouse.y - self.position.y);

                activeMouseHandlers[action](mouse, dragOffset, e);

                e.preventDefault();
                return false;
            };
            canvas.addEventListener(action, internalMouseHandlers[action], true);
        });

        /**
         * Configure public and private properties.
         */

        Object.defineProperties(this, {
            // Public, read-only properties
            ctx: {
                enumerable: true,
                value: ctx
            },
            width: {
                enumerable: true,
                get: function get() {
                    return canvas.width;
                }
            },
            height: {
                enumerable: true,
                get: function get() {
                    return canvas.height;
                }
            },
            position: {
                enumerable: true,
                value: position
            },

            // Private members
            _canvas: {
                value: canvas
            },
            _shapes: {
                value: []
            },
            _style: {
                value: style
            },
            _actions: {
                value: internalMouseHandlers
            },
            _handlers: {
                get: function get() {
                    return activeMouseHandlers;
                },
                set: function set(value) {
                    activeMouseHandlers = value;
                }
            }
        });
    }

    /**
     * Adds a shape that needs to be rendered in the draw cycle and dirty's the canvas ensuring that the shape will
     * be included in the next refresh.
     */


    (0, _createClass3.default)(DrawingSurface, [{
        key: 'addShape',
        value: function addShape(shape) {
            this._shapes.push(shape);
            this.valid = false;
        }
    }, {
        key: 'removeAllShapes',
        value: function removeAllShapes() {
            this._shapes.length = 0;
        }

        /**
         * Removes everything from the canvas.
         */

    }, {
        key: 'clear',
        value: function clear() {
            this.ctx.clearRect(0, 0, this.width, this.height);
        }

        /**
         * Called by the renderer. Calls draw() on all children, but only if the canvas was invalidated.
         */

    }, {
        key: 'draw',
        value: function draw() {
            // Only redraw when needed.
            if (!this.valid) {
                this.clear();

                // Draw all shapes (note that internally shapes should not render if they're off the canvas).
                for (var i = 0; i < this._shapes.length; i++) {
                    this._shapes[i].draw(this);
                }

                this.valid = true;
            }
        }

        /**
         * Creates an object with x and y defined, set to the mouse position relative to the state's canvas
         * If you wanna be super-correct this can be tricky, we have to worry about padding and borders
         */

    }, {
        key: 'getMousePosition',
        value: function getMousePosition(e) {
            var element = this._canvas;
            var offsetX = 0;
            var offsetY = 0;
            var mx = void 0;
            var my = void 0;

            // Compute the total offset
            if (element.offsetParent !== undefined) {
                do {
                    offsetX += element.offsetLeft;
                    offsetY += element.offsetTop;
                } while (element = element.offsetParent);
            }

            // Add padding and border style widths to offset
            // Also add the <html> offsets in case there's a position:fixed bar
            offsetX += this._style.padding.left + this._style.border.left + this._style.offset.left;
            offsetY += this._style.padding.top + this._style.border.top + this._style.offset.top;

            mx = e.pageX - offsetX;
            my = e.pageY - offsetY;

            return new _Point.Point(mx, my);
        }

        /**
         * Sets mouse handlers.
         * @param handlers - An object containing one or more of mousemove, mouseup, and mousedown events.
         */

    }, {
        key: 'setMouseEventHandlers',
        value: function setMouseEventHandlers(handlers) {
            this._handlers = handlers;
        }

        /**
         * Removes all mouse handlers. Call when mouse events are no longer necessary.
         */

    }, {
        key: 'clearMouseHandlers',
        value: function clearMouseHandlers() {
            var _this = this;

            (0, _lbsPiDash.forEach)(this._actions, function (action, name) {
                _this._canvas.removeEventListener(name, action);
            });
            this.setMouseEventHandlers({});
        }
        /**
         * Memory management. Please call when the drawing surface goes out of scope.
         */

    }, {
        key: 'destroy',
        value: function destroy() {
            this.clearMouseHandlers();
        }
    }]);
    return DrawingSurface;
}();

function calculateStyleOffsets(canvas) {
    var style = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
        offset: {},
        padding: {},
        border: {}
    };

    // This complicates things a little but but fixes mouse co-ordinate problems when there's a border or
    // padding. See getMousePosition for more detail.
    if (document.defaultView && document.defaultView.getComputedStyle) {
        style.padding.left = parseInt(document.defaultView.getComputedStyle(canvas, null).paddingLeft, 10) || 0;
        style.padding.top = parseInt(document.defaultView.getComputedStyle(canvas, null).paddingTop, 10) || 0;
        style.border.left = parseInt(document.defaultView.getComputedStyle(canvas, null).borderLeftWidth, 10) || 0;
        style.border.top = parseInt(document.defaultView.getComputedStyle(canvas, null).borderTopWidth, 10) || 0;
    }

    // Some pages have fixed-position bars at the top or left of the page; they will mess up mouse coordinates
    // and this fixes that.
    var htmlEl = document.body.parentNode;
    style.offset.top = htmlEl.offsetTop;
    style.offset.left = htmlEl.offsetLeft;

    return style;
}

/***/ }),

/***/ 302:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.RoiHandlerFixedWidth = undefined;

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(2);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(21);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(20);

var _inherits3 = _interopRequireDefault(_inherits2);

var _RoiHandlerBase2 = __webpack_require__(137);

var _ClearRectangle = __webpack_require__(138);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Defines a handler that allows users to place a fixed-size box on the screen.
 */
var RoiHandlerFixedWidth = exports.RoiHandlerFixedWidth = function (_RoiHandlerBase) {
    (0, _inherits3.default)(RoiHandlerFixedWidth, _RoiHandlerBase);

    function RoiHandlerFixedWidth() {
        (0, _classCallCheck3.default)(this, RoiHandlerFixedWidth);
        return (0, _possibleConstructorReturn3.default)(this, (RoiHandlerFixedWidth.__proto__ || Object.getPrototypeOf(RoiHandlerFixedWidth)).apply(this, arguments));
    }

    (0, _createClass3.default)(RoiHandlerFixedWidth, [{
        key: 'init',
        value: function init(surface) {
            var self = this;

            // Retrieve the dimensions of the box.
            var width = self.settings.width;
            var height = self.settings.height;

            // Create the box and add it to the surface so it will be rendered in the surface's draw() phase.
            var shape = new _ClearRectangle.ClearRectangle(0, 0, width, height);
            surface.addShape(shape);

            // Define mouse handler actions.
            surface.setMouseEventHandlers({
                // When the user moves the mouse the rectangle should trace the mouse.
                mousemove: function mousemove(mouse, dragOffset, e) {
                    // move the rectangle's center to the new mouse position (to get the center we divide w/h by 2).
                    shape.x = mouse.x - shape.w / 2;
                    shape.y = mouse.y - shape.h / 2;

                    // Invalidate the surface, triggering a repaint on the next draw() cycle.
                    surface.valid = false;
                },


                // Once the user lets go of the mouse we're done.
                mousedown: function mousedown(mouse, dragOffset, e) {
                    surface.clearMouseHandlers();

                    self.signalUserActionComplete(shape);

                    _RoiHandlerBase2.RoiHandlerBase.normalizeAndOffset(shape, self.settings.viewportInfo);

                    self.finish(shape);
                }
            });
        }
    }]);
    return RoiHandlerFixedWidth;
}(_RoiHandlerBase2.RoiHandlerBase);

/***/ }),

/***/ 303:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.RoiHandlerResizable = undefined;

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(2);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(21);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(20);

var _inherits3 = _interopRequireDefault(_inherits2);

var _RoiHandlerBase2 = __webpack_require__(137);

var _ClearRectangle = __webpack_require__(138);

var _defines = __webpack_require__(0);

var _defines2 = _interopRequireDefault(_defines);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Defines a handler that allows a user to draw a box on the viewport.
 */
var RoiHandlerResizable = exports.RoiHandlerResizable = function (_RoiHandlerBase) {
    (0, _inherits3.default)(RoiHandlerResizable, _RoiHandlerBase);

    function RoiHandlerResizable() {
        (0, _classCallCheck3.default)(this, RoiHandlerResizable);
        return (0, _possibleConstructorReturn3.default)(this, (RoiHandlerResizable.__proto__ || Object.getPrototypeOf(RoiHandlerResizable)).apply(this, arguments));
    }

    (0, _createClass3.default)(RoiHandlerResizable, [{
        key: 'init',
        value: function init(surface) {
            var self = this;
            var state = {};

            surface.setMouseEventHandlers({
                // On mouse down the user declares his intent to start drawing. This is our origin, so we capture it.
                mousedown: function mousedown(mouse, dragOffset, e) {
                    // Create a 0 dimensional rectangle at the cursor position.
                    state.shape = new _ClearRectangle.ClearRectangle(mouse.x, mouse.y, 0, 0);
                    // We want to drag from where we first clicked, so we save the offset.
                    state.dragOffset = {
                        x: mouse.x - state.shape.x,
                        y: mouse.y - state.shape.y
                    };

                    surface.addShape(state.shape);
                },


                // Once the user has started drawing, we resize our rectangle to match the user's cursor position.
                mousemove: function mousemove(mouse, dragOffset, e) {
                    // If the user hasn't started drawing, do nothing.
                    if (state.shape) {
                        // Set the height and width.
                        state.shape.w = mouse.x - state.dragOffset.x - state.shape.x;
                        state.shape.h = mouse.y - state.dragOffset.y - state.shape.y;

                        // Constrain the height and width to the max dimensions.
                        state.shape.w = constrain(state.shape.w, _defines2.default.IMAGESERVER_MAXJDIM);
                        state.shape.h = constrain(state.shape.h, _defines2.default.IMAGESERVER_MAXJDIM);

                        // Invalidate the surface, triggering a repaint on the next draw() cycle.
                        surface.valid = false;
                    }
                },


                // Once the user lets go of the mouse we're done.
                mouseup: function mouseup(mouse, dragOffset, e) {
                    surface.clearMouseHandlers();

                    // Silly but you never know...
                    if (!state.shape) {
                        return;
                    }

                    self.signalUserActionComplete(state.shape);

                    _RoiHandlerBase2.RoiHandlerBase.normalizeAndOffset(state.shape, self.settings.viewportInfo);

                    self.finish(state.shape);
                }
            });
        }
    }]);
    return RoiHandlerResizable;
}(_RoiHandlerBase2.RoiHandlerBase);

// Constrains abs(val) to max, preserving sign.


function constrain(val, max) {
    var sign = val < 0 ? -1 : +1;
    if (Math.abs(val) > max) {
        val = max * sign;
    }
    return val;
}

/***/ }),

/***/ 304:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.RoiHandlerWysiwyg = undefined;

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(2);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(21);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(20);

var _inherits3 = _interopRequireDefault(_inherits2);

var _ClearRectangle = __webpack_require__(138);

var _RoiHandlerBase2 = __webpack_require__(137);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var RoiHandlerWysiwyg = exports.RoiHandlerWysiwyg = function (_RoiHandlerBase) {
    (0, _inherits3.default)(RoiHandlerWysiwyg, _RoiHandlerBase);

    function RoiHandlerWysiwyg() {
        (0, _classCallCheck3.default)(this, RoiHandlerWysiwyg);
        return (0, _possibleConstructorReturn3.default)(this, (RoiHandlerWysiwyg.__proto__ || Object.getPrototypeOf(RoiHandlerWysiwyg)).apply(this, arguments));
    }

    (0, _createClass3.default)(RoiHandlerWysiwyg, [{
        key: 'init',
        value: function init(surface) {
            var _this2 = this;

            var shape = new _ClearRectangle.ClearRectangle(0, 0, surface.width, surface.height);

            setTimeout(function () {
                _this2.signalUserActionComplete(shape);

                _RoiHandlerBase2.RoiHandlerBase.normalizeAndOffset(shape, _this2.settings.viewportInfo);

                _this2.finish(shape);
            });
        }
    }]);
    return RoiHandlerWysiwyg;
}(_RoiHandlerBase2.RoiHandlerBase);

/***/ }),

/***/ 305:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.BaseRectangle = undefined;

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(2);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(21);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(20);

var _inherits3 = _interopRequireDefault(_inherits2);

var _Rectangle = __webpack_require__(309);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Base class for drawable rectangle. Must be inherited. Children must implement "paint(ctx, offsetX, offsetY, drawing.w, drawing.h)" method.
 */
var BaseRectangle = exports.BaseRectangle = function (_Base) {
    (0, _inherits3.default)(BaseRectangle, _Base);

    function BaseRectangle(x, y, w, h, options) {
        (0, _classCallCheck3.default)(this, BaseRectangle);

        var _this = (0, _possibleConstructorReturn3.default)(this, (BaseRectangle.__proto__ || Object.getPrototypeOf(BaseRectangle)).call(this, x, y, w, h));

        _this._options = options;
        return _this;
    }

    (0, _createClass3.default)(BaseRectangle, [{
        key: 'draw',
        value: function draw(surface) {
            var drawing = this.clone().normalize();
            var offsetX = drawing.x + surface.position.x;
            var offsetY = drawing.y + surface.position.y;
            var ctx = surface.ctx;

            // We can skip the drawing if the element has moved off the screen:
            if (offsetX > surface.width || offsetY > surface.height || +drawing.w < 0 || offsetY + drawing.h < 0) {
                return;
            }

            this.paint(ctx, offsetX, offsetY, drawing.w, drawing.h);
        }
    }]);
    return BaseRectangle;
}(_Rectangle.Rectangle);

/***/ }),

/***/ 306:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.SolidBackground = undefined;

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(2);

var _createClass3 = _interopRequireDefault(_createClass2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Fills a canvas with a solid background color.
 */
var SolidBackground = exports.SolidBackground = function () {
    function SolidBackground(fillStyle) {
        (0, _classCallCheck3.default)(this, SolidBackground);

        this._fillStyle = fillStyle;
    }

    (0, _createClass3.default)(SolidBackground, [{
        key: "draw",
        value: function draw(surface) {
            var ctx = surface.ctx;

            ctx.fillStyle = this._fillStyle;
            ctx.fillRect(0, 0, surface.width, surface.height);
        }
    }]);
    return SolidBackground;
}();

/***/ }),

/***/ 313:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.findNodes = findNodes;
// In IE, NodeList (returned from querySelectorAll) doesn't support forEach.
// This converts querySelectorAll's result to an array to give us forEach.
function findNodes(container, selector) {
    return Array.from(container.querySelectorAll(selector));
}

/***/ }),

/***/ 345:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(564);

__webpack_require__(462);

/***/ }),

/***/ 363:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.makeVerticalTabs = undefined;

var _domHelpers = __webpack_require__(313);

var makeVerticalTabs = exports.makeVerticalTabs = function makeVerticalTabs(rootEl) {
    var selectedIndex = void 0;
    var tabButtons = (0, _domHelpers.findNodes)(rootEl, '.tab-button-container > .tab-button');
    var containers = (0, _domHelpers.findNodes)(rootEl, '.tab-content-container > .tab-content');
    var state = {
        get selectedIndex() {
            return selectedIndex;
        },
        onChange: function onChange() {}
    };

    containers.forEach(function (container) {
        return container.classList.add('tab-content-hidden');
    });

    tabButtons.forEach(function (tabButton, ix) {
        return tabButton.addEventListener('change', selectTab.bind(null, ix));
    });

    function selectTab(ix) {
        if (selectedIndex !== undefined) {
            containers[selectedIndex].classList.add('tab-content-hidden');
        }
        containers[ix].classList.remove('tab-content-hidden');
        selectedIndex = ix;
        state.onChange();
    }

    selectTab(0);

    return state;
};

/***/ }),

/***/ 443:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.ViewportHelper = ViewportHelper;

var _defines = __webpack_require__(0);

var _defines2 = _interopRequireDefault(_defines);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * This class assists in manipulating the state of viewport overlays when capturing a snapshot.
 */
function ViewportHelper(viewport) {
    var $vpContainer = viewport.vpDivGet('outer');
    var $vpInner = viewport.vpDivGet();
    var $viewportItems = $vpContainer.find('div.us_overlay, div.us_superoverlay').filter(':visible');
    var $uScopeItems = $(_defines2.default.idHashROOT).find('#' + _defines2.default.idTOPTOOLBARV + ', .uscope-dialog').filter(':visible');
    var transform = void 0;

    this.hideOverlays = function () {
        $viewportItems.hide();
        $uScopeItems.hide();
        transform = $vpInner.css('transform');
        $vpInner.css('transform', '');
    };

    this.showOverlays = function () {
        $viewportItems.show();
        $uScopeItems.show();
        $vpInner.css('transform', transform);
    };
}

/***/ }),

/***/ 444:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.ClientDownloader = undefined;

var _regenerator = __webpack_require__(10);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(9);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(2);

var _createClass3 = _interopRequireDefault(_createClass2);

var _constants = __webpack_require__(80);

var _helpers = __webpack_require__(4);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Provides a cross-browser compatible way to download images to the user's machine (without needing an explicit server call).
 */
var ClientDownloader = exports.ClientDownloader = function () {
    /**
     * Constructor.
     * @param scanner - A ViewportScanner instance.
     */
    function ClientDownloader(scanner) {
        (0, _classCallCheck3.default)(this, ClientDownloader);

        Object.defineProperties(this, {
            _scanner: { value: scanner }
        });
        Object.freeze(this);
    }

    /**
     * Downloads a tile to the user's machine.
     */


    (0, _createClass3.default)(ClientDownloader, [{
        key: 'download',
        value: function () {
            var _ref = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee(viewport, rectangle, zoom) {
                var _this = this;

                var filename = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : _constants.DEFAULT_FILE_NAME;

                var _ref2, blob, uri;

                return _regenerator2.default.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                _context.next = 2;
                                return this._scanner.capture(viewport, rectangle, zoom);

                            case 2:
                                _ref2 = _context.sent;
                                blob = _ref2.blob;
                                uri = _ref2.uri;


                                (0, _helpers.download)({ uri: uri, blob: blob, filename: filename });

                                // Don't leave hanging references to generated images.
                                setTimeout(function () {
                                    _this._scanner.cleanup();
                                }, 2000);

                            case 7:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, this);
            }));

            function download(_x, _x2, _x3) {
                return _ref.apply(this, arguments);
            }

            return download;
        }()
    }]);
    return ClientDownloader;
}();

/***/ }),

/***/ 445:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.ServerDownloader = undefined;

var _regenerator = __webpack_require__(10);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(9);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(2);

var _createClass3 = _interopRequireDefault(_createClass2);

var _defines = __webpack_require__(0);

var _defines2 = _interopRequireDefault(_defines);

var _Point = __webpack_require__(107);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ServerDownloader = exports.ServerDownloader = function () {
    /**
     * Constructor.
     * @param serviceLocator - Annotations service locator.
     */
    function ServerDownloader(serviceLocator) {
        (0, _classCallCheck3.default)(this, ServerDownloader);

        Object.defineProperty(this, '_serviceLocator', {
            get: function get() {
                return serviceLocator;
            }
        });
    }

    /**
     * Downloads a tile to the user's machine.
     */


    (0, _createClass3.default)(ServerDownloader, [{
        key: 'download',
        value: function () {
            var _ref = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee(viewport, rectangle, zoom) {
                var angle, annotationsService, points, layerId;
                return _regenerator2.default.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                angle = 0;
                                annotationsService = this._serviceLocator.annotationsService;
                                points = convert(rectangle, zoom);
                                _context.next = 5;
                                return annotationsService.layers.maybeCreateLayerAndGetId('webviewer-snapshots');

                            case 5:
                                layerId = _context.sent;
                                _context.next = 8;
                                return annotationsService.regCreate({ layerId: layerId, type: _defines2.default.eAnTypes.rect, angle: angle, zoom: zoom, points: points }, true);

                            case 8:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, this);
            }));

            function download(_x, _x2, _x3) {
                return _ref.apply(this, arguments);
            }

            return download;
        }()
    }]);
    return ServerDownloader;
}();

/**
 * Converts a rectangle to a list of points used by region objects (TL, TR, BR, BL).
 * @param rectangle
 * @param zoom
 */


function convert(rectangle, zoom) {
    return [new _Point.Point(rectangle.x, rectangle.y).multiply(zoom, zoom), new _Point.Point(rectangle.x + rectangle.w, rectangle.y).multiply(zoom, zoom), new _Point.Point(rectangle.x + rectangle.w, rectangle.y + rectangle.h).multiply(zoom, zoom), new _Point.Point(rectangle.x, rectangle.y + rectangle.h).multiply(zoom, zoom)];
}

/***/ }),

/***/ 446:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.ViewportScanner = undefined;

var _regenerator = __webpack_require__(10);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(9);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(2);

var _createClass3 = _interopRequireDefault(_createClass2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Reads a tile from the image server and stuffs it into a blob. Can handle cross origin requests.
 */
var ViewportScanner = exports.ViewportScanner = function () {
    /**
     * The constructor!
     * @param readers (object) List of reader instances that will read the viewport and render it onto a canvas. The
     * order the readers are listed is the order they will render; higher-index readers render on top of lower-index ones.
     * (hint: the annotations reader should be passed in second, since it renders on top of the tiles!)
     */
    function ViewportScanner(readers) {
        (0, _classCallCheck3.default)(this, ViewportScanner);

        this._readers = readers;
        Object.freeze(this);
    }

    (0, _createClass3.default)(ViewportScanner, [{
        key: 'capture',
        value: function () {
            var _ref = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee(viewport, rectangle, zoom) {
                var canvas, ctx;
                return _regenerator2.default.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                _context.next = 2;
                                return Promise.all(this._readers.map(function (reader) {
                                    return reader.capture(viewport, rectangle, zoom);
                                }));

                            case 2:

                                // Create a canvas to render the results onto
                                canvas = document.createElement('canvas');
                                ctx = canvas.getContext('2d');

                                canvas.height = rectangle.h;
                                canvas.width = rectangle.w;

                                this._readers.forEach(function (reader) {
                                    return reader.render(ctx);
                                });

                                // Extract the result.
                                return _context.abrupt('return', new Promise(function (resolve, reject) {
                                    var blob = void 0;
                                    var uri = void 0;
                                    if (canvas.toBlob) {
                                        canvas.toBlob(function (blob) {
                                            uri = URL.createObjectURL(blob);
                                            resolve({ blob: blob, uri: uri });
                                        });
                                    } else if (canvas.msToBlob) {
                                        blob = canvas.msToBlob();
                                        resolve({ blob: blob, uri: uri });
                                    } else {
                                        uri = canvas.toDataURL('image/png');
                                        resolve({ blob: blob, uri: uri });
                                    }
                                }));

                            case 8:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, this);
            }));

            function capture(_x, _x2, _x3) {
                return _ref.apply(this, arguments);
            }

            return capture;
        }()
    }, {
        key: 'cleanup',
        value: function cleanup() {
            this._readers.forEach(function (reader) {
                return reader.cleanup();
            });
        }
    }]);
    return ViewportScanner;
}();

/***/ }),

/***/ 447:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _annotationsReaderFactory = __webpack_require__(451);

Object.keys(_annotationsReaderFactory).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _annotationsReaderFactory[key];
    }
  });
});

var _ImageReader = __webpack_require__(450);

Object.keys(_ImageReader).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _ImageReader[key];
    }
  });
});

var _ClientDownloader = __webpack_require__(444);

Object.keys(_ClientDownloader).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _ClientDownloader[key];
    }
  });
});

var _ServerDownloader = __webpack_require__(445);

Object.keys(_ServerDownloader).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _ServerDownloader[key];
    }
  });
});

var _ViewportScanner = __webpack_require__(446);

Object.keys(_ViewportScanner).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _ViewportScanner[key];
    }
  });
});

/***/ }),

/***/ 448:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.AnnotationsReader = undefined;

var _regenerator = __webpack_require__(10);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(9);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(2);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(21);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(20);

var _inherits3 = _interopRequireDefault(_inherits2);

var _AnnotationsReaderBase = __webpack_require__(158);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AnnotationsReader = exports.AnnotationsReader = function (_AnnotationsReaderBas) {
    (0, _inherits3.default)(AnnotationsReader, _AnnotationsReaderBas);

    function AnnotationsReader() {
        (0, _classCallCheck3.default)(this, AnnotationsReader);
        return (0, _possibleConstructorReturn3.default)(this, (AnnotationsReader.__proto__ || Object.getPrototypeOf(AnnotationsReader)).apply(this, arguments));
    }

    (0, _createClass3.default)(AnnotationsReader, [{
        key: '_capture',
        value: function _capture(svgData, meta) {
            var _this2 = this;

            return new Promise(function () {
                var _ref = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee(resolve, reject) {
                    var blob, blobUri, img;
                    return _regenerator2.default.wrap(function _callee$(_context) {
                        while (1) {
                            switch (_context.prev = _context.next) {
                                case 0:
                                    // Render the annotations to an image
                                    blob = new Blob([svgData], { type: 'image/svg+xml;charset=utf-8' });
                                    blobUri = URL.createObjectURL(blob);
                                    img = new Image();

                                    img.crossOrigin = 'anonymous';

                                    img.onload = function () {
                                        // store info needed for rendering.
                                        _this2._image = img;
                                        // X and Y were scaled against the viewport during the drawing phase, so we don't need to re-apply that
                                        // transformation here. Width and height data come from the raw SVG, which has not yet been scaled, so
                                        // we scale it here.
                                        _this2._position = {
                                            x: meta.x,
                                            y: meta.y,
                                            w: meta.w * meta.scale,
                                            h: meta.h * meta.scale
                                        };
                                        resolve();
                                    };
                                    img.onerror = function (e) {
                                        reject(e);
                                    };
                                    img.src = blobUri;

                                case 7:
                                case 'end':
                                    return _context.stop();
                            }
                        }
                    }, _callee, _this2);
                }));

                return function (_x, _x2) {
                    return _ref.apply(this, arguments);
                };
            }());
        }
    }, {
        key: 'render',
        value: function render(context) {
            context.drawImage(this._image, -this._position.x, -this._position.y, this._position.w, this._position.h);
        }
    }, {
        key: 'cleanup',
        value: function cleanup() {
            if (this.image) {
                URL.revokeObjectURL(this.image.src);
                delete this.rectangle;
                delete this.image;
            } else {
                // ('Called Annotations::cleanup() more twice.'); // eslint-disable-line no-undef
            }
        }
    }]);
    return AnnotationsReader;
}(_AnnotationsReaderBase.AnnotationsReaderBase);

/***/ }),

/***/ 449:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.AnnotationsReaderIE = undefined;

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(2);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(21);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(20);

var _inherits3 = _interopRequireDefault(_inherits2);

var _AnnotationsReaderBase = __webpack_require__(158);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AnnotationsReaderIE = exports.AnnotationsReaderIE = function (_AnnotationsReaderBas) {
    (0, _inherits3.default)(AnnotationsReaderIE, _AnnotationsReaderBas);

    function AnnotationsReaderIE() {
        (0, _classCallCheck3.default)(this, AnnotationsReaderIE);
        return (0, _possibleConstructorReturn3.default)(this, (AnnotationsReaderIE.__proto__ || Object.getPrototypeOf(AnnotationsReaderIE)).apply(this, arguments));
    }

    (0, _createClass3.default)(AnnotationsReaderIE, [{
        key: '_capture',
        value: function _capture(svgData, meta) {
            // store info needed for rendering.
            this.svgData = svgData;

            // X and Y were scaled against the viewport during the drawing phase, but the CANVG SVG renderer doesn't know
            // that, so when it sees that the height and width of the SVG don't match the height and width we specify, it
            // scales position accordingly. We need to undo that. Width and height data come from the raw SVG, which has not
            // yet been scaled, so we scale it here.
            this._position = {
                x: meta.x / meta.scale,
                y: meta.y / meta.scale,
                w: meta.w * meta.scale,
                h: meta.h * meta.scale
            };
        }
    }, {
        key: 'render',
        value: function render(context) {
            context.drawSvg(this.svgData, -this._position.x, -this._position.y, this._position.w, this._position.h);
        }
    }, {
        key: 'cleanup',
        value: function cleanup() {
            delete this.svgData;
            delete this.image;
        }
    }]);
    return AnnotationsReaderIE;
}(_AnnotationsReaderBase.AnnotationsReaderBase);

/***/ }),

/***/ 450:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.requestTileAsBlob = exports.ImageReader = undefined;

var _regenerator = __webpack_require__(10);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(9);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(2);

var _createClass3 = _interopRequireDefault(_createClass2);

var requestTileAsBlob = exports.requestTileAsBlob = function () {
    var _ref3 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee3(url) {
        var request;
        return _regenerator2.default.wrap(function _callee3$(_context3) {
            while (1) {
                switch (_context3.prev = _context3.next) {
                    case 0:
                        request = new XMLHttpRequest();
                        return _context3.abrupt('return', new Promise(function (resolve, reject) {
                            request.addEventListener('load', function (e) {
                                if (request.status > 299) {
                                    reject(request);
                                } else {
                                    var blob = new Blob([request.response], {
                                        type: request.getResponseHeader('content-type')
                                    });
                                    resolve(blob);
                                }
                            });
                            request.open('GET', url);
                            request.responseType = 'arraybuffer';
                            request.setRequestHeader('Accept', 'image/webp,image/*,*/*;q=0.8');
                            request.send();
                        }));

                    case 2:
                    case 'end':
                        return _context3.stop();
                }
            }
        }, _callee3, this);
    }));

    return function requestTileAsBlob(_x6) {
        return _ref3.apply(this, arguments);
    };
}();

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ImageReader = exports.ImageReader = function () {
    function ImageReader() {
        (0, _classCallCheck3.default)(this, ImageReader);
    }

    (0, _createClass3.default)(ImageReader, [{
        key: 'capture',
        value: function () {
            var _ref = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee2(viewport, rectangle, zoom) {
                var _this = this;

                return _regenerator2.default.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                return _context2.abrupt('return', new Promise(function () {
                                    var _ref2 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee(resolve, reject) {
                                        var rawUri, blob, blobUri, img;
                                        return _regenerator2.default.wrap(function _callee$(_context) {
                                            while (1) {
                                                switch (_context.prev = _context.next) {
                                                    case 0:
                                                        rawUri = viewport.urlBuilder.region(rectangle.x, rectangle.y, rectangle.w, rectangle.h, zoom);
                                                        _context.next = 3;
                                                        return requestTileAsBlob(rawUri);

                                                    case 3:
                                                        blob = _context.sent;
                                                        blobUri = URL.createObjectURL(blob);
                                                        img = new Image();

                                                        img.crossOrigin = 'anonymous';

                                                        img.onload = function () {
                                                            _this.image = img;
                                                            resolve();
                                                        };
                                                        img.onerror = function (e) {
                                                            reject(e);
                                                        };
                                                        img.src = blobUri;

                                                    case 10:
                                                    case 'end':
                                                        return _context.stop();
                                                }
                                            }
                                        }, _callee, _this);
                                    }));

                                    return function (_x4, _x5) {
                                        return _ref2.apply(this, arguments);
                                    };
                                }()));

                            case 1:
                            case 'end':
                                return _context2.stop();
                        }
                    }
                }, _callee2, this);
            }));

            function capture(_x, _x2, _x3) {
                return _ref.apply(this, arguments);
            }

            return capture;
        }()
    }, {
        key: 'render',
        value: function render(context) {
            context.drawImage(this.image, 0, 0);
        }
    }, {
        key: 'cleanup',
        value: function cleanup() {
            if (this.image) {
                URL.revokeObjectURL(this.image.src);
                delete this.image;
            } else {
                // ('Called ImageReader::cleanup() more twice.'); // eslint-disable-line no-undef
            }
        }
    }]);
    return ImageReader;
}();

/***/ }),

/***/ 451:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.createAnnotationsReader = undefined;

var _AnnotationsReaderBase = __webpack_require__(158);

var _AnnotationsReader = __webpack_require__(448);

var _AnnotationsReaderIE = __webpack_require__(449);

var _annotationsReaderHelper = __webpack_require__(452);

var createAnnotationsReader = exports.createAnnotationsReader = function createAnnotationsReader(annotationsServiceLocator) {
    // Need a service locator to export annotations.
    if (!annotationsServiceLocator) {
        return new _AnnotationsReaderBase.AnnotationsReaderBase();
    }

    var helper = (0, _annotationsReaderHelper.createHelper)(annotationsServiceLocator);

    var canvas = document.createElement('canvas');
    // Test if browser does not use non-standards msToBlob, which throws a security error exporting svg data from canvas
    if (!!canvas.toBlob && !canvas.msToBlob) {
        return new _AnnotationsReader.AnnotationsReader(helper);
        // Test if browser uses non-standards msToBlob and confirm the canvg library is loaded in.
    } else if (!!canvas.msToBlob && window.CanvasRenderingContext2D && window.CanvasRenderingContext2D.prototype.drawSvg) {
        return new _AnnotationsReaderIE.AnnotationsReaderIE(helper);
    }

    return new _AnnotationsReaderBase.AnnotationsReaderBase();
};

/***/ }),

/***/ 452:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
/**
 * Reads annotation information from the active annotations service and extracts the SVG data.
 * @param serviceLocator (object) The service locator, injected from the Annotations extension
 */
var createHelper = exports.createHelper = function createHelper(serviceLocator) {
    return {
        getSvgData: function getSvgData(viewport, rectangle, captureZoom) {
            // Extract annotations as blob
            var svg = serviceLocator.annotationsService.paper.canvas;
            var $svg = $(svg);
            var content = new XMLSerializer().serializeToString(svg);

            // Explicitly set the height and width; otherwise the 100% rules will constrain the SVG to the canvas's height/width
            // and the svg overlay will only be visible at the image origin!
            var meta = {
                x: rectangle.x,
                y: rectangle.y,
                h: $svg.height(),
                w: $svg.width(),
                scale: viewport.getVPView().zoom / captureZoom
            };
            content = content.replace('height="100%"', 'height="' + meta.h + '"');
            content = content.replace('width="100%"', 'width="' + meta.w + '" ');

            // The XML Serializer appears to add an extra xmlns attribute in IE, which prevents the image from
            // rendering. If we just blindly remove the attribute then Chrome/FF fail to render. So we check to see if
            // there's more than one and remove the first. Note that if we were to somehow end up with more than 2
            // the following logic would need to change, but YAGNI.
            if (content.match(/xmlns=/g).length > 1) {
                content = content.replace('xmlns="http://www.w3.org/2000/svg"', '');
            }

            return {
                content: content,
                meta: meta
            };
        }
    };
};

/***/ }),

/***/ 453:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.RegionOfInterest = undefined;

var _regenerator = __webpack_require__(10);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(9);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(2);

var _createClass3 = _interopRequireDefault(_createClass2);

var _keyCodes = __webpack_require__(139);

var _roiHelperMethods = __webpack_require__(456);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Coordinates the capturing of a region of interest. Given a viewport and settings, this class
 * will create a drawing surface suitable for allowing user interaction, create the appropriate
 * Roi capture mechanism (one of several RoiHandlers). It defers control to the RoiHandler during
 * the capture phase and returns it to the caller once the RoiHandler indicates completion. It
 * also cleans up after itself when done.
 */
var RegionOfInterest = exports.RegionOfInterest = function () {
    function RegionOfInterest(eventChannel, renderer) {
        (0, _classCallCheck3.default)(this, RegionOfInterest);

        this.eventChannel = eventChannel;
        this.renderer = renderer;
    }

    /**
     * @param viewport (object) - The viewport where the drawing will be attached.
     * @param settings (object) - Report settings extracted from user preferences.
     */


    (0, _createClass3.default)(RegionOfInterest, [{
        key: 'draw',
        value: function draw(viewport, settings) {
            var _this = this;

            var viewportElement = viewport.vpDivGet('outer')[0];
            var canvas = (0, _roiHelperMethods.createCanvas)(viewportElement, settings);
            var surface = (0, _roiHelperMethods.createDrawingSurface)(this.renderer, canvas, viewportElement);
            var roiHandler = (0, _roiHelperMethods.createRoiHandler)(this.eventChannel, viewport, settings);

            // Provide definition for event handler that can be cleaned up when done.
            var escapeKeyHandler = function escapeKeyHandler(e) {
                if (e.keyCode === _keyCodes.keyCodes.escape) {
                    _this.eventChannel.trigger('drawing:user-cancelled');
                    cleanup();
                }
            };

            // Clean up. Call when done.
            var cleanup = function cleanup() {
                document.removeEventListener('keyup', escapeKeyHandler);
                turnOffEventChannel();
                _this.renderer.removeSurface(surface);

                // NOTE: IE depends on browser-compatibility.js for the call to {domElement}.remove()
                canvas.remove();
            };

            // Setup event listeners.
            var turnOffEventChannel = this.eventChannel.on('drawing:user-action-complete', function () {
                var _ref = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee(rectangle) {
                    return _regenerator2.default.wrap(function _callee$(_context) {
                        while (1) {
                            switch (_context.prev = _context.next) {
                                case 0:
                                    if (!(rectangle.area <= 0)) {
                                        _context.next = 2;
                                        break;
                                    }

                                    return _context.abrupt('return');

                                case 2:

                                    (0, _roiHelperMethods.playShutterSound)();
                                    _context.next = 5;
                                    return (0, _roiHelperMethods.animateArea)(surface, rectangle);

                                case 5:
                                    cleanup();

                                case 6:
                                case 'end':
                                    return _context.stop();
                            }
                        }
                    }, _callee, _this);
                }));

                return function (_x) {
                    return _ref.apply(this, arguments);
                };
            }());
            document.addEventListener('keyup', escapeKeyHandler);

            // Now that everything's configured, fire it up.
            roiHandler.init(surface);
            this.renderer.start();
        }
    }]);
    return RegionOfInterest;
}();

/***/ }),

/***/ 454:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.RenderEngine = RenderEngine;
/**
 * This module coordinates the rendering of many drawing surfaces on a single "thread".
 */

function RenderEngine() {
    var self = this;
    // Stores all surfaces that will be rendered in the render cycle.
    var renderQueue = [];
    // The master timer, received from the browser.
    var frameId = null;

    /**
     * Walks all surfaces and calls draw() on them.
     * NOTE 1: Silently eats all exceptions.
     * NOTE 2: Will stop the master timer if the renderQueue is empty.
     */
    function renderSurfaces() {
        if (renderQueue.length === 0) {
            self.stop();
            return;
        }

        for (var i = 0; i < renderQueue.length; i++) {
            try {
                renderQueue[i].draw();
            } catch (e) {
                // ('Error drawing surface.', e); // eslint-disable-line no-undef
                // TODO: Maybe handle troublesome surfaces?
            }
        }
        // Note: use setTimeout so individual renders actually finish before attempting to render again. The implication
        // of this is that refreshes may happen less often than interval.
        frameId = requestAnimationFrame(renderSurfaces);
    }

    /**
     * Simply adds a drawing surface to render queue.
     */
    this.addSurface = function (surface) {
        renderQueue.push(surface);
    };

    /**
     * Removes a drawing surface from the render queue. Also calls destroy on the surface.
     */
    this.removeSurface = function (surface) {
        surface.destroy();
        renderQueue.splice(renderQueue.indexOf(surface), 1);
    };

    /**
     * Stops the master timer and empties the render queue.
     */
    this.stop = function () {
        if (frameId) {
            cancelAnimationFrame(frameId);
            frameId = null;
        }
        renderQueue.length = 0;
    };

    /**
     * Starts the master timer.
     */
    this.start = function () {
        if (!frameId) {
            renderSurfaces();
        }
    };
}

/***/ }),

/***/ 455:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _ClearRectangle = __webpack_require__(138);

Object.keys(_ClearRectangle).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _ClearRectangle[key];
    }
  });
});

var _DrawingSurface = __webpack_require__(301);

Object.keys(_DrawingSurface).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _DrawingSurface[key];
    }
  });
});

var _RegionOfInterest = __webpack_require__(453);

Object.keys(_RegionOfInterest).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _RegionOfInterest[key];
    }
  });
});

var _RenderEngine = __webpack_require__(454);

Object.keys(_RenderEngine).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _RenderEngine[key];
    }
  });
});

var _RoiHandlerBase = __webpack_require__(137);

Object.keys(_RoiHandlerBase).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _RoiHandlerBase[key];
    }
  });
});

var _RoiHandlerFixedWidth = __webpack_require__(302);

Object.keys(_RoiHandlerFixedWidth).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _RoiHandlerFixedWidth[key];
    }
  });
});

var _RoiHandlerResizable = __webpack_require__(303);

Object.keys(_RoiHandlerResizable).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _RoiHandlerResizable[key];
    }
  });
});

var _RoiHandlerWysiwyg = __webpack_require__(304);

Object.keys(_RoiHandlerWysiwyg).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _RoiHandlerWysiwyg[key];
    }
  });
});

var _SolidBackground = __webpack_require__(306);

Object.keys(_SolidBackground).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _SolidBackground[key];
    }
  });
});

/***/ }),

/***/ 456:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _defineProperty2 = __webpack_require__(159);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _roiModeLookupTable;
// Removed in 12.4. Will restore in Mustang.
// import {RoiHandlerFixedAspect} from './RoiHandlerFixedAspect';


exports.animateArea = animateArea;
exports.playShutterSound = playShutterSound;
exports.createCanvas = createCanvas;
exports.createDrawingSurface = createDrawingSurface;
exports.createRoiHandler = createRoiHandler;

var _SolidRectangle = __webpack_require__(457);

var _RoiHandlerFixedWidth = __webpack_require__(302);

var _RoiHandlerResizable = __webpack_require__(303);

var _RoiHandlerWysiwyg = __webpack_require__(304);

var _DrawingSurface = __webpack_require__(301);

var _SolidBackground = __webpack_require__(306);

var _constants = __webpack_require__(80);

var _b64Data = __webpack_require__(609);

var _b64Data2 = _interopRequireDefault(_b64Data);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function animateArea(surface, area) {
    return new Promise(function (resolve) {
        var delta = _constants.ANIMATE_SPEED.ASCENDING;
        var r = new _SolidRectangle.SolidRectangle(area.x, area.y, area.w, area.h, { opacity: 0 });
        var animator = {
            draw: function draw(surface) {
                if (r.opacity < 0) {
                    // When we're done we're done.
                    return;
                }

                // Draw the rectangle.
                r.draw(surface);

                // Increment the opacity.
                r.opacity += delta;

                // Switch directions when we peak.
                if (r.opacity >= 1 && delta === _constants.ANIMATE_SPEED.ASCENDING) {
                    delta = _constants.ANIMATE_SPEED.DESCENDING;
                }

                // Flag the surface to redraw on the next paint cycle.
                setTimeout(function () {
                    return surface.valid = false;
                });

                // Let people know when we're done.
                if (r.opacity <= 0) {
                    resolve();
                }
            }
        };

        surface.removeAllShapes();
        surface.addShape(animator);
    });
}

function playShutterSound() {
    var source = 'shutter.mp3';
    var data = _b64Data2.default[source];
    var audio = new Audio('data:' + data.mimeType + ';' + data.encoding + ',' + data.payload);
    audio.play();
}

function createCanvas(viewportElement, settings) {
    var canvas = document.createElement('canvas');

    // Style the canvas
    canvas.className = _constants.CSS_CLASS_NAMES.CANVAS_BASE_CLASS;
    canvas.classList.add('mode-' + settings.mode);
    canvas.height = viewportElement.offsetHeight;
    canvas.width = viewportElement.offsetWidth;

    // Put the canvas on the viewport div.
    viewportElement.appendChild(canvas);

    return canvas;
}

function createDrawingSurface(renderer, canvas, viewportElement) {
    var surface = new _DrawingSurface.DrawingSurface(canvas, viewportElement);
    surface.addShape(new _SolidBackground.SolidBackground(_constants.SNAPSHOT_DRAW_BACKGROUND_COLOR));
    renderer.addSurface(surface);

    return surface;
}

var roiModeLookupTable = (_roiModeLookupTable = {}, (0, _defineProperty3.default)(_roiModeLookupTable, _constants.MODES.FIXED, _RoiHandlerFixedWidth.RoiHandlerFixedWidth), (0, _defineProperty3.default)(_roiModeLookupTable, _constants.MODES.RESIZABLE, _RoiHandlerResizable.RoiHandlerResizable), (0, _defineProperty3.default)(_roiModeLookupTable, _constants.MODES.WYSIWYG, _RoiHandlerWysiwyg.RoiHandlerWysiwyg), _roiModeLookupTable);

function createRoiHandler(eventChannel, viewport, settings) {
    return new roiModeLookupTable[settings.mode](eventChannel, viewport, settings);
}

/***/ }),

/***/ 457:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.SolidRectangle = undefined;

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(2);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(21);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(20);

var _inherits3 = _interopRequireDefault(_inherits2);

var _BaseRectangle2 = __webpack_require__(305);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DEFAULT_OPTIONS = {
    fill: '#fff',
    opacity: 1
};

/**
 * This fills a rectangle-shaped area on a canvas.
 */

var SolidRectangle = exports.SolidRectangle = function (_BaseRectangle) {
    (0, _inherits3.default)(SolidRectangle, _BaseRectangle);

    function SolidRectangle(x, y, w, h) {
        var options = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};
        (0, _classCallCheck3.default)(this, SolidRectangle);
        return (0, _possibleConstructorReturn3.default)(this, (SolidRectangle.__proto__ || Object.getPrototypeOf(SolidRectangle)).call(this, x, y, w, h, Object.assign({}, DEFAULT_OPTIONS, options)));
    }

    (0, _createClass3.default)(SolidRectangle, [{
        key: 'paint',
        value: function paint(ctx, x, y, w, h) {
            ctx.globalAlpha = this._options.opacity;
            ctx.clearRect(x, y, w, h);
            ctx.fillStyle = this._options.fill;
            ctx.fillRect(x, y, w, h);
        }
    }, {
        key: 'fill',
        get: function get() {
            return this._options.fill;
        },
        set: function set(value) {
            this._options.fill = value;
        }
    }, {
        key: 'opacity',
        get: function get() {
            return this._options.opacity;
        },
        set: function set(value) {
            this._options.opacity = value;
        }
    }]);
    return SolidRectangle;
}(_BaseRectangle2.BaseRectangle);

/***/ }),

/***/ 458:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Validator = exports.rules = undefined;

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(2);

var _createClass3 = _interopRequireDefault(_createClass2);

var _constants = __webpack_require__(80);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var validModes = values(_constants.MODES);
var validDestinations = values(_constants.DESTINATIONS);

var rules = exports.rules = {
    height: {
        test: function test(value) {
            if (!isNumber(value)) {
                throw new Error('Height must be a number.');
            }
            if (value <= 1 || value > _constants.MAX_HEIGHT) {
                throw new Error('Height must be between 1 and ' + _constants.MAX_HEIGHT);
            }
        }
    },
    width: {
        test: function test(value) {
            if (!isNumber(value)) {
                throw new Error('Width must be a number.');
            }
            if (value <= 1 || value > _constants.MAX_WIDTH) {
                throw new Error('Width must be between 1 and ' + _constants.MAX_WIDTH);
            }
        }
    },
    mode: {
        test: function test(value) {
            if (validModes.indexOf(value) === -1) {
                throw new Error('Unknown mode ' + value);
            }
        }
    },
    destination: {
        test: function test(value) {
            if (validDestinations.indexOf(value) === -1) {
                throw new Error('Unknown mode ' + value);
            }
        }
    }
};

function isNumber(val) {
    return !isNaN(Number(val));
}

// Can't invest too much time designing this house of cards... Vue coming soon!

var Validator = exports.Validator = function () {
    function Validator(rules) {
        (0, _classCallCheck3.default)(this, Validator);

        this.rules = rules;
    }

    (0, _createClass3.default)(Validator, [{
        key: 'validate',
        value: function validate(key, value) {
            this.rules[key].test(value);
        }
    }]);
    return Validator;
}();

function values(o) {
    return Object.keys(o).map(function (k) {
        return o[k];
    });
}

/***/ }),

/***/ 459:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.SnapshotSettingsService = SnapshotSettingsService;

var _lbsPiDash = __webpack_require__(5);

var _constants = __webpack_require__(80);

// Create the prefToSetting and settingToPref lookup tables. This is a bit hokey, but it allows us to
// name settings in the snapshot context without the redundant "snapshot" prefix while adding the prefix
// to the userPreferences class.
var prefToSetting = {};
Object.keys(_constants.defaultSettings).forEach(function (key) {
    return prefToSetting['snapshot-' + key] = key;
});
var settingToPref = (0, _lbsPiDash.invert)(prefToSetting);

/**
 * Creates a wrapepr service around userPrefs that manages a user's snapshot settings.
 */
function SnapshotSettingsService(userPrefs, validator) {
    var service = this;

    service.events = userPrefs.events.$new();

    // Add snapshot defaults to user prefs.
    userPrefs.registerPreferences(packUserPreferences(_constants.defaultSettings));

    // Create pass-through properties to the user prefs obj.
    (0, _lbsPiDash.forEach)(settingToPref, function (pref, setting) {
        Object.defineProperty(service, setting, {
            enumerable: true,
            get: function get() {
                return userPrefs.get(pref);
            },
            set: function set(value) {
                // Validate before setting. NOTE: this can throw.
                validator.validate(prefToSetting[pref], value);

                // Update user prefs and publish the change.
                userPrefs.set(pref, value);
                service.events.trigger('settings-service:change');
            }
        });
    });

    // If "onLoad" is defined, call it when user settings are loaded.
    userPrefs.events.on('load', function () {
        service.events.trigger('settings-service:change');
    });
}

// Prefix all snapshot settings with "snapshot" to namespace them in the settings table.
function packUserPreferences(defaultSettings) {
    var o = {};
    (0, _lbsPiDash.forEach)(defaultSettings, function (value, key) {
        o[settingToPref[key]] = value;
    });
    return o;
}

/***/ }),

/***/ 460:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _constants = __webpack_require__(80);

Object.keys(_constants).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _constants[key];
    }
  });
});

var _SettingsValidator = __webpack_require__(458);

Object.keys(_SettingsValidator).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _SettingsValidator[key];
    }
  });
});

var _SnapshotSettingsService = __webpack_require__(459);

Object.keys(_SnapshotSettingsService).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _SnapshotSettingsService[key];
    }
  });
});

/***/ }),

/***/ 461:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _regenerator = __webpack_require__(10);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(9);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

exports.go = go;

var _i18nEn = __webpack_require__(136);

var _i18nEn2 = _interopRequireDefault(_i18nEn);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function go(notifications, viewport, eventChannel, settings, snapshotUi, downloader, regionOfInterest, viewportHelper) {
    var startCapturePhase = function () {
        var _ref = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee(rectangle, zoom) {
            return _regenerator2.default.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            if (!(rectangle.area === 0)) {
                                _context.next = 3;
                                break;
                            }

                            wrapThingsUp();
                            return _context.abrupt('return');

                        case 3:

                            notifications.information('Starting download...');

                            _context.prev = 4;
                            _context.next = 7;
                            return downloader.download(viewport, rectangle, zoom);

                        case 7:
                            wrapThingsUp(_i18nEn2.default.notices['success']);
                            _context.next = 13;
                            break;

                        case 10:
                            _context.prev = 10;
                            _context.t0 = _context['catch'](4);

                            wrapThingsUp(_i18nEn2.default.notices['download-failed'], _context.t0);

                        case 13:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, this, [[4, 10]]);
        }));

        return function startCapturePhase(_x, _x2) {
            return _ref.apply(this, arguments);
        };
    }();

    // If the user presses escape, just clean up.
    eventChannel.on('drawing:user-cancelled', wrapThingsUp);
    // Restore UI functionality as soon as the user's done drawing
    eventChannel.on('drawing:user-action-complete', restoreAllTheHiddenThings);

    eventChannel.on('drawing:complete', startCapturePhase);

    hideUnwantedItemsFromView();
    startDrawPhase();

    function hideUnwantedItemsFromView() {
        snapshotUi.hide();
        viewportHelper.hideOverlays();
    }

    function restoreAllTheHiddenThings() {
        // Since the tool is now the main UI, it should come back.
        snapshotUi.show();
        viewportHelper.showOverlays();
    }

    function startDrawPhase() {
        try {
            regionOfInterest.draw(viewport, settings);
        } catch (e) {
            wrapThingsUp(_i18nEn2.default.notices['create-failed'], e);
        }
    }

    function wrapThingsUp(message, exception) {
        if (message) {
            notifications[exception ? 'warning' : 'done'](message);
        }

        if (exception) {
            // (exception); // eslint-disable-line no-undef
        }

        // In some cases this is redundant, but better to err on the side of restoring functionality to the user.
        restoreAllTheHiddenThings();

        // We're done. Clean up event listeners.
        eventChannel.$destroy();
    }
}

/***/ }),

/***/ 462:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _publicApi = __webpack_require__(6);

var _publicApi2 = _interopRequireDefault(_publicApi);

var _index = __webpack_require__(455);

var _index2 = __webpack_require__(447);

var _toolbarButton = __webpack_require__(468);

var _showUiButton = __webpack_require__(467);

var _ViewportHelper = __webpack_require__(443);

var _index3 = __webpack_require__(460);

var _index4 = __webpack_require__(466);

var _snapshotEventCoordinator = __webpack_require__(461);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_publicApi2.default.plugins.register({
    name: 'us:snapshot',

    extends: 'uScope',

    // TODO: Make optional.
    dependencies: ['us:annotations:service-locator'],

    canStart: function canStart() {
        // Need access to the URL API.
        return !!window.URL;
    },


    constructor: function constructor(uScope, annotationsServiceLocator) {
        var settings = new _index3.SnapshotSettingsService(uScope.userPrefs, new _index3.Validator(_index3.rules));
        var dataBinder = new _index4.DataBinder(settings);
        var ui = new _index4.MainUi(document.body, dataBinder, doSnapshot);

        var settingsButton = (0, _showUiButton.createToolUiButton)(ui);
        var button = (0, _toolbarButton.createButton)(settingsButton, doSnapshot);

        uScope.topToolbar.addButton(button);

        function doSnapshot() {
            var viewport = uScope.getThisImage();
            if (!viewport) {
                return;
            }

            var eventChannel = uScope.events.$new();
            var regionOfInterest = new _index.RegionOfInterest(eventChannel, new _index.RenderEngine());
            var viewportHelper = new _ViewportHelper.ViewportHelper(viewport);
            var scanner = new _index2.ViewportScanner([new _index2.ImageReader(), (0, _index2.createAnnotationsReader)(annotationsServiceLocator)]);
            var downloader = settings.destination === _index3.DESTINATIONS.SERVER ? new _index2.ServerDownloader(annotationsServiceLocator) : new _index2.ClientDownloader(scanner);

            (0, _snapshotEventCoordinator.go)(uScope.notifications, viewport, eventChannel, settings, ui, downloader, regionOfInterest, viewportHelper);
        }
    }
});

/***/ }),

/***/ 463:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.DataBinder = undefined;

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(2);

var _createClass3 = _interopRequireDefault(_createClass2);

var _domHelpers = __webpack_require__(313);

var _constants = __webpack_require__(80);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Provides two way binding between a user interface and a settings object. Changes to either are reflected in the other.
 * Note this isn't a pattern we want to propagate throughout this code. This is a stopgap till we include an MV* framework.
 */
var DataBinder = exports.DataBinder = function () {
    function DataBinder(settings) {
        (0, _classCallCheck3.default)(this, DataBinder);

        this.settings = settings;
    }

    (0, _createClass3.default)(DataBinder, [{
        key: 'bind',
        value: function bind(container, tabs) {
            var settings = this.settings;
            var modeList = (0, _domHelpers.findNodes)(container, 'select.snapshot-mode-options')[0];
            var modeLabel = (0, _domHelpers.findNodes)(container, 'span.mode-name')[0];
            var sizeList = (0, _domHelpers.findNodes)(container, '.' + _constants.CSS_CLASS_NAMES.SIZE_OPTIONS + ' input');
            var sizeListContainer = (0, _domHelpers.findNodes)(container, '.mode-settings-container');
            var destinationList = (0, _domHelpers.findNodes)(container, '.' + _constants.CSS_CLASS_NAMES.DESTINATION_BUTTONS + ' input');
            var messageContainer = container.querySelectorAll('.snapshot-settings-message')[0];
            var errorMessage = void 0;

            function syncSettingsToUi() {
                var shouldSetDimensions = _constants.needsDimensions[settings.mode];
                bindSelectBox(modeList, settings.mode);
                bindCheckboxes(destinationList, settings.destination);
                modeLabel.innerText = _constants.MODE_NAMES[settings.mode];

                sizeList.forEach(function (n) {
                    n.value = settings[n.name];
                    n.disabled = !shouldSetDimensions;
                });

                if (shouldSetDimensions) {
                    removeClass(sizeListContainer, _constants.CSS_CLASS_NAMES.DISABLED);
                } else {
                    addClass(sizeListContainer, _constants.CSS_CLASS_NAMES.DISABLED);
                }

                syncMessageText();
            }

            function syncMessageText() {
                var message = errorMessage;

                if (tabs.selectedIndex === 1) {
                    message = _constants.destinationInfo[settings.destination];
                } else if (!message) {
                    message = _constants.modeInfo[settings.mode].replace('$WIDTH', settings.width).replace('$HEIGHT', settings.height);
                }
                messageContainer.innerText = message;
            }

            function bindUiToSettings() {
                bindNode(modeList);
                bindList(destinationList);

                sizeList.forEach(function (n) {
                    n.addEventListener('change', function (e) {
                        if (!n.value) {
                            n.value = settings[n.name];
                        } else {
                            tryToSet(n, n.name, n.value);
                        }
                    });
                });

                syncMessageText();
            }

            function bindList(list) {
                list.forEach(bindNode);
            }
            function bindNode(node) {
                node.addEventListener('change', function (e) {
                    tryToSet(node, node.name, e.target.value);
                });
            }

            function tryToSet(el, key, value) {
                try {
                    settings[key] = value;
                    errorMessage = '';
                    removeClass(messageContainer, _constants.CSS_CLASS_NAMES.VALIDATION_ERROR);
                    removeClass(el, _constants.CSS_CLASS_NAMES.VALIDATION_ERROR);
                } catch (err) {
                    errorMessage = err.message;
                    addClass(messageContainer, _constants.CSS_CLASS_NAMES.VALIDATION_ERROR);
                    addClass(el, _constants.CSS_CLASS_NAMES.VALIDATION_ERROR);
                }
                syncMessageText();
            }

            syncSettingsToUi();
            bindUiToSettings();
            tabs.onChange = syncMessageText;

            // When settings change, resync the UI.
            this.settings.events.on('settings-service:change', syncSettingsToUi);
        }
    }]);
    return DataBinder;
}();

// IE doesn't like `element.classList` so we have to work around it


function addClass(el, className) {
    if (Array.isArray(el)) {
        el.forEach(function (e) {
            return addClass(e, className);
        });
    }
    var cName = el.className || '';
    var classes = cName.split(' ');
    if (classes.indexOf(className) === -1) {
        classes.push(className);
        el.className = classes.join(' ').trim();
    }
}
function removeClass(el, className) {
    if (Array.isArray(el)) {
        el.forEach(function (e) {
            return removeClass(e, className);
        });
    }
    var cName = el.className || '';
    var classes = cName.split(' ');
    var at = classes.indexOf(className);
    if (at > -1) {
        classes.splice(at, 1);
        el.className = classes.join(' ');
    }
}
function bindCheckboxes(list, selected) {
    list.forEach(function (n) {
        if (n.value === selected) {
            // Note that n.setAttribute('checked', true); doesn't work reliably in IE tests. It seems to work fine in-app though.
            n.checked = true;
        }
    });
}
function bindSelectBox(list, selected) {
    (0, _domHelpers.findNodes)(list, 'option').forEach(function (n) {
        // Note that n.setAttribute('checked', true); doesn't work reliably in IE tests. It seems to work fine in-app though.
        n.selected = n.value === selected;
    });
}

/***/ }),

/***/ 464:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.template = undefined;

var _i18nEn = __webpack_require__(136);

var _i18nEn2 = _interopRequireDefault(_i18nEn);

var _constants = __webpack_require__(80);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// This is the monster HTML template...

var template = exports.template = '\n    <div class="lbs-dialog-header" title="">\n        <h2>' + _i18nEn2.default['snapshot-settings'] + '</h2>\n        <button class="lbs-dialog-close-button"></button>\n    </div>\n    <div class="lbs-dialog-body">\n        <div class="lbs-vertical-tab-container">\n            <div class="tab-button-container">\n                <label class="tab-button">\n                    <input type="radio" name="tab-button" checked />\n                    <span>\n                        <span>' + _i18nEn2.default['image-settings'] + '</span>\n                        <span class="icon image-settings-icon"></span>\n                    </span>\n                </label>\n                <label class="tab-button">\n                    <input type="radio" name="tab-button" />\n                    <span>\n                        <span>' + _i18nEn2.default['advanced-settings'] + '</span>\n                        <span class="icon advanced-settings-icon"></span>\n                    </span>\n                </label>\n            </div>\n            <div class="tab-content-container">\n                <div class="tab-content snapshot-image-settings">\n                    <div class="image-settings-upper mode-selection-container">\n                        <label class="lbs-select-container">\n                            <span>' + _i18nEn2.default['select-mode'] + ':</span>\n                            <select class="snapshot-mode-options" name="mode">\n                                <option value="' + _constants.MODES.WYSIWYG + '">' + _i18nEn2.default['full-view'] + '</option>\n                                <option value="' + _constants.MODES.FIXED + '">' + _i18nEn2.default['fixed-size'] + '</option>\n                                <option value="' + _constants.MODES.RESIZABLE + '">' + _i18nEn2.default['resizable'] + '</option>\n<!-- N/A for 12.4\n                                <option value="' + _constants.MODES.FIXED_ASPECT + '">${i18n[\'fixed-aspect\']}</option>\n-->\n                            </select>\n                        </label>\n                    </div>';

exports.template = template += '<div class="image-settings-lower">\n                        <div class="mode-settings-container">\n                            <h3>\n                                <span class="mode-name"></span>\n                                ' + _i18nEn2.default['settings'] + ':\n                            </h3>\n                            <div class="' + _constants.CSS_CLASS_NAMES.SIZE_OPTIONS + '">\n                                <label>\n                                    <span>' + _i18nEn2.default['width'] + ':</span>\n                                    <input name="width" type="text" class="lbs-form-control" />\n                                    <span>' + _i18nEn2.default['px'] + '</span>\n                                </label>\n                                <label>\n                                    <span>' + _i18nEn2.default['height'] + ':</span>\n                                    <input name="height" type="text" class="lbs-form-control" />\n                                    <span>' + _i18nEn2.default['px'] + '</span>\n                                </label>\n                            </div>\n                        </div>\n                        <div class="big-red-button-container">\n                            <button class="the-big-red-button">' + _i18nEn2.default['capture'] + '</button>\n                        </div>\n                    </div>\n                </div>\n                <div class="tab-content snapshot-advanced-settings">\n                    <dl>\n                        <dt>' + _i18nEn2.default['save-to'] + ':</dt>\n                        <dd class="' + _constants.CSS_CLASS_NAMES.DESTINATION_BUTTONS + ' lbs-form-group">\n                            <label>\n                                <input class="lbs-form-control" type="radio" name="destination" value="' + _constants.DESTINATIONS.CLIENT + '" />\n                                <span title="' + _i18nEn2.default['local-description'] + '">' + _i18nEn2.default['local'] + '</span>\n                            </label>\n                            <label>\n                                <input class="lbs-form-control" type="radio" name="destination" value="' + _constants.DESTINATIONS.SERVER + '" />\n                                <span title="' + _i18nEn2.default['remote-description'] + '">' + _i18nEn2.default['remote'] + '</span>\n                            </label>\n                        </dd>\n                    </dl>\n                </div>\n            </div>\n        </div>\n    </div>\n    <div class="lbs-dialog-footer">\n        <div class="snapshot-settings-message-container">\n            <h3>' + _i18nEn2.default['description'] + ':</h3>\n            <div class="snapshot-settings-message"></div>\n        </div>\n    </div>\n';

/***/ }),

/***/ 465:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.MainUi = undefined;

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _draggableMixin = __webpack_require__(146);

var _draggableMixin2 = _interopRequireDefault(_draggableMixin);

var _makeVerticalTabs = __webpack_require__(363);

var _keyCodes = __webpack_require__(139);

var _MainUi = __webpack_require__(464);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Generates the settings user interface. Handles data binding to settings.
 */
var MainUi =
/**
 * Creates a Settings UI
 * @param rootNode - the node to attach the dialog to
 * @param settingsDataBinder - binds this UI to a settings service
 * @param doSnapshot - callback to start the snapshot
 */
exports.MainUi = function MainUi(rootNode, settingsDataBinder, doSnapshot) {
    (0, _classCallCheck3.default)(this, MainUi);

    var self = this;
    var container = void 0;
    var elementToAppearNear = void 0;
    var isOpen = false;
    var isVisible = false;
    // Apply the draggable mixin, allowing this control to be dragged.
    Object.keys(_draggableMixin2.default.methods).forEach(function (method) {
        self[method] = _draggableMixin2.default.methods[method].bind(self);
    });

    Object.assign(self, {
        // Used by draggable mixin to locate the position of the dialog.
        getPosition: function getPosition() {
            // Extract the left and top positions from the container's transform styling.
            return {
                left: parseInt(container.style.left, 10),
                top: parseInt(container.style.top)
            };
        },

        // Used by the draggable mixin to reposition the dialog.
        moveTo: function moveTo(position) {
            container.style.left = position.left;
            container.style.top = position.top;
        },


        // This is a bit of a hack... The tool is reshown after a snapshot is completed. Since a snapshot can be
        // started outside the tool, we should have a means to "start" and "stop" it independent of showing
        // and hiding the dialog. The open and close methods provide it.
        open: function open() {
            isOpen = true;
            self.show();
        },
        close: function close() {
            self.hide();
            isOpen = false;
        },


        // Like the name suggests, shows the dialog. Note that it will ONLY show if the dialog has previously
        // been opened. TODO: Maybe a better name is "restore()", but then what do we do with close() and hide()?
        show: function show() {
            if (!isOpen || isVisible) {
                return;
            }
            isVisible = true;
            container.classList.remove('lbs-dialog-leave-active');
            container.classList.add('lbs-dialog-enter');
            positionOnce();
            rootNode.appendChild(container);
            document.addEventListener('keyup', escapeKeyHandler);

            setTimeout(function () {
                container.classList.remove('lbs-dialog-enter');
            });
        },


        // Like the name suggests, hide the dialog.
        hide: function hide() {
            if (!isVisible) {
                return;
            }
            isVisible = false;
            cleanup();
            container.classList.add('lbs-dialog-leave-active');
            listenOnce(container, 'transitionend', function () {
                if (!isVisible) {
                    container.remove();
                    container.classList.remove('lbs-dialog-leave-active');
                }
            });
        },


        // Shows if hidden and hides if visible.
        toggle: function toggle(el) {
            elementToAppearNear = el;
            (isVisible ? self.hide : self.show)();
        }
    });

    // Only position the dialog once. After first run this function becomes a noop.
    var positionOnce = function (_positionOnce) {
        function positionOnce() {
            return _positionOnce.apply(this, arguments);
        }

        positionOnce.toString = function () {
            return _positionOnce.toString();
        };

        return positionOnce;
    }(function () {
        // Try to appear near the toolbar button, if "elementToAppearNear" is defined, otherwise center on the root node.
        if (elementToAppearNear) {
            self.moveTo({
                top: elementToAppearNear.offsetParent.offsetParent.offsetTop + elementToAppearNear.offsetTop + 'px',
                left: elementToAppearNear.offsetLeft + 30 + 'px'
            });
        } else {
            self.moveTo({
                top: $(rootNode).height() / 2 - 157 + 'px',
                left: $(rootNode).width() / 2 - 200 + 'px'
            });
        }
        positionOnce = function positionOnce() {};
    });

    // Handler for when the escape key is pressed.
    var escapeKeyHandler = function escapeKeyHandler(e) {
        if (e.keyCode === _keyCodes.keyCodes.escape) {
            self.hide();
            cleanup();
        }
    };
    // Always clean up after yourself.
    function cleanup() {
        document.removeEventListener('keyup', escapeKeyHandler);
    }

    // Create the div encapsulating the user settings and apply the template.
    container = document.createElement('div');
    // Note: IE doesn't support classlist.Add() with multiple classes
    container.className += 'lbs-dialog-container snapshot-settings-dialog';
    container.innerHTML = _MainUi.template;

    var tabs = (0, _makeVerticalTabs.makeVerticalTabs)(container);

    // Wire up the buttons to close the dialog.
    var closeButton = container.querySelectorAll('.lbs-dialog-close-button')[0];
    closeButton.addEventListener('click', self.close);

    // Wire up the repositioning logic.
    self.setDragTarget(container.querySelectorAll('.lbs-dialog-header')[0], container);

    // Wire up the "take a snapshot" button
    var bigRedButton = container.querySelectorAll('.the-big-red-button')[0];
    bigRedButton.addEventListener('click', doSnapshot);

    // Bind the settings object to the user interface.
    settingsDataBinder.bind(container, tabs);
};

/**
 * Shorthand method for listening to a dom event only once.
 * @param element Element that event will be triggered on
 * @param event Event to listen for
 * @param callback callback to handle the event
 */


function listenOnce(element, event, callback) {
    function doCallback(e) {
        callback(e);
        element.removeEventListener(event, doCallback);
    }

    element.addEventListener(event, doCallback);
}

/***/ }),

/***/ 466:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _DataBinder = __webpack_require__(463);

Object.keys(_DataBinder).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _DataBinder[key];
    }
  });
});

var _MainUi = __webpack_require__(465);

Object.keys(_MainUi).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _MainUi[key];
    }
  });
});

/***/ }),

/***/ 467:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.createToolUiButton = undefined;

var _i18nEn = __webpack_require__(136);

var _i18nEn2 = _interopRequireDefault(_i18nEn);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SETTINGS_BUTTON_TOOLTIP = _i18nEn2.default['settings-icon-alt-text'];

var createToolUiButton = exports.createToolUiButton = function createToolUiButton(mainUi) {
    var settingsButton = document.createElement('button');
    // Note: IE doesn't support classlist.Add() with multiple classes
    settingsButton.className += 'snapshot-settings-button uscope-toolbar-button';
    settingsButton.title = SETTINGS_BUTTON_TOOLTIP;
    settingsButton.addEventListener('click', function (e) {
        // Open the UI, vs showing it, to ensure it becomes visible.
        mainUi.open(settingsButton);
        e.preventDefault();
        e.stopImmediatePropagation();
        return false;
    });
    return settingsButton;
};

/***/ }),

/***/ 468:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.createButton = undefined;

var _i18nEn = __webpack_require__(136);

var _i18nEn2 = _interopRequireDefault(_i18nEn);

var _toolbarButtonFactory = __webpack_require__(79);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var BUTTON_CLASS = 'uscope-snapshot-button';
var BUTTON_HOVER_TEXT = _i18nEn2.default['toolbar-icon-alt-text'];

var createButton = exports.createButton = function createButton(settingsButton, onClick) {
    // Create a button to add to uScope's toolbar.
    var button = (0, _toolbarButtonFactory.createToolbarButton)({
        className: BUTTON_CLASS,

        title: BUTTON_HOVER_TEXT,

        onClick: onClick
    });

    // Setup the button UI that includes the settings button
    var container = document.createElement('div');
    container.classList.add('toolbar-button-container');
    container.appendChild(button);
    container.appendChild(settingsButton);

    return container;
};

/***/ }),

/***/ 50:
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(51), __esModule: true };

/***/ }),

/***/ 51:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(106);
__webpack_require__(76);
__webpack_require__(77);
__webpack_require__(62);
module.exports = __webpack_require__(12).Promise;

/***/ }),

/***/ 52:
/***/ (function(module, exports) {

module.exports = function(it, Constructor, name, forbiddenField){
  if(!(it instanceof Constructor) || (forbiddenField !== undefined && forbiddenField in it)){
    throw TypeError(name + ': incorrect invocation!');
  } return it;
};

/***/ }),

/***/ 53:
/***/ (function(module, exports, __webpack_require__) {

var ctx         = __webpack_require__(19)
  , call        = __webpack_require__(56)
  , isArrayIter = __webpack_require__(55)
  , anObject    = __webpack_require__(13)
  , toLength    = __webpack_require__(104)
  , getIterFn   = __webpack_require__(105)
  , BREAK       = {}
  , RETURN      = {};
var exports = module.exports = function(iterable, entries, fn, that, ITERATOR){
  var iterFn = ITERATOR ? function(){ return iterable; } : getIterFn(iterable)
    , f      = ctx(fn, that, entries ? 2 : 1)
    , index  = 0
    , length, step, iterator, result;
  if(typeof iterFn != 'function')throw TypeError(iterable + ' is not iterable!');
  // fast case for arrays with default iterator
  if(isArrayIter(iterFn))for(length = toLength(iterable.length); length > index; index++){
    result = entries ? f(anObject(step = iterable[index])[0], step[1]) : f(iterable[index]);
    if(result === BREAK || result === RETURN)return result;
  } else for(iterator = iterFn.call(iterable); !(step = iterator.next()).done; ){
    result = call(iterator, f, step.value, entries);
    if(result === BREAK || result === RETURN)return result;
  }
};
exports.BREAK  = BREAK;
exports.RETURN = RETURN;

/***/ }),

/***/ 54:
/***/ (function(module, exports) {

// fast apply, http://jsperf.lnkit.com/fast-apply/5
module.exports = function(fn, args, that){
  var un = that === undefined;
  switch(args.length){
    case 0: return un ? fn()
                      : fn.call(that);
    case 1: return un ? fn(args[0])
                      : fn.call(that, args[0]);
    case 2: return un ? fn(args[0], args[1])
                      : fn.call(that, args[0], args[1]);
    case 3: return un ? fn(args[0], args[1], args[2])
                      : fn.call(that, args[0], args[1], args[2]);
    case 4: return un ? fn(args[0], args[1], args[2], args[3])
                      : fn.call(that, args[0], args[1], args[2], args[3]);
  } return              fn.apply(that, args);
};

/***/ }),

/***/ 55:
/***/ (function(module, exports, __webpack_require__) {

// check on default Array iterator
var Iterators  = __webpack_require__(47)
  , ITERATOR   = __webpack_require__(3)('iterator')
  , ArrayProto = Array.prototype;

module.exports = function(it){
  return it !== undefined && (Iterators.Array === it || ArrayProto[ITERATOR] === it);
};

/***/ }),

/***/ 56:
/***/ (function(module, exports, __webpack_require__) {

// call something on iterator step with safe closing on error
var anObject = __webpack_require__(13);
module.exports = function(iterator, fn, value, entries){
  try {
    return entries ? fn(anObject(value)[0], value[1]) : fn(value);
  // 7.4.6 IteratorClose(iterator, completion)
  } catch(e){
    var ret = iterator['return'];
    if(ret !== undefined)anObject(ret.call(iterator));
    throw e;
  }
};

/***/ }),

/***/ 564:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 57:
/***/ (function(module, exports, __webpack_require__) {

var ITERATOR     = __webpack_require__(3)('iterator')
  , SAFE_CLOSING = false;

try {
  var riter = [7][ITERATOR]();
  riter['return'] = function(){ SAFE_CLOSING = true; };
  Array.from(riter, function(){ throw 2; });
} catch(e){ /* empty */ }

module.exports = function(exec, skipClosing){
  if(!skipClosing && !SAFE_CLOSING)return false;
  var safe = false;
  try {
    var arr  = [7]
      , iter = arr[ITERATOR]();
    iter.next = function(){ return {done: safe = true}; };
    arr[ITERATOR] = function(){ return iter; };
    exec(arr);
  } catch(e){ /* empty */ }
  return safe;
};

/***/ }),

/***/ 58:
/***/ (function(module, exports, __webpack_require__) {

var global    = __webpack_require__(7)
  , macrotask = __webpack_require__(25).set
  , Observer  = global.MutationObserver || global.WebKitMutationObserver
  , process   = global.process
  , Promise   = global.Promise
  , isNode    = __webpack_require__(28)(process) == 'process';

module.exports = function(){
  var head, last, notify;

  var flush = function(){
    var parent, fn;
    if(isNode && (parent = process.domain))parent.exit();
    while(head){
      fn   = head.fn;
      head = head.next;
      try {
        fn();
      } catch(e){
        if(head)notify();
        else last = undefined;
        throw e;
      }
    } last = undefined;
    if(parent)parent.enter();
  };

  // Node.js
  if(isNode){
    notify = function(){
      process.nextTick(flush);
    };
  // browsers with MutationObserver
  } else if(Observer){
    var toggle = true
      , node   = document.createTextNode('');
    new Observer(flush).observe(node, {characterData: true}); // eslint-disable-line no-new
    notify = function(){
      node.data = toggle = !toggle;
    };
  // environments with maybe non-completely correct, but existent Promise
  } else if(Promise && Promise.resolve){
    var promise = Promise.resolve();
    notify = function(){
      promise.then(flush);
    };
  // for other environments - macrotask based on:
  // - setImmediate
  // - MessageChannel
  // - window.postMessag
  // - onreadystatechange
  // - setTimeout
  } else {
    notify = function(){
      // strange IE + webpack dev server bug - use .call(global)
      macrotask.call(global, flush);
    };
  }

  return function(fn){
    var task = {fn: fn, next: undefined};
    if(last)last.next = task;
    if(!head){
      head = task;
      notify();
    } last = task;
  };
};

/***/ }),

/***/ 59:
/***/ (function(module, exports, __webpack_require__) {

var hide = __webpack_require__(35);
module.exports = function(target, src, safe){
  for(var key in src){
    if(safe && target[key])target[key] = src[key];
    else hide(target, key, src[key]);
  } return target;
};

/***/ }),

/***/ 60:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global      = __webpack_require__(7)
  , core        = __webpack_require__(12)
  , dP          = __webpack_require__(33)
  , DESCRIPTORS = __webpack_require__(32)
  , SPECIES     = __webpack_require__(3)('species');

module.exports = function(KEY){
  var C = typeof core[KEY] == 'function' ? core[KEY] : global[KEY];
  if(DESCRIPTORS && C && !C[SPECIES])dP.f(C, SPECIES, {
    configurable: true,
    get: function(){ return this; }
  });
};

/***/ }),

/***/ 609:
/***/ (function(module, exports) {

module.exports = {
	"shutter.mp3": {
		"mimeType": "audio/mp3",
		"encoding": "base64",
		"payload": "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"
	}
};

/***/ }),

/***/ 61:
/***/ (function(module, exports, __webpack_require__) {

// 7.3.20 SpeciesConstructor(O, defaultConstructor)
var anObject  = __webpack_require__(13)
  , aFunction = __webpack_require__(34)
  , SPECIES   = __webpack_require__(3)('species');
module.exports = function(O, D){
  var C = anObject(O).constructor, S;
  return C === undefined || (S = anObject(C)[SPECIES]) == undefined ? D : aFunction(S);
};

/***/ }),

/***/ 62:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var LIBRARY            = __webpack_require__(74)
  , global             = __webpack_require__(7)
  , ctx                = __webpack_require__(19)
  , classof            = __webpack_require__(82)
  , $export            = __webpack_require__(45)
  , isObject           = __webpack_require__(46)
  , aFunction          = __webpack_require__(34)
  , anInstance         = __webpack_require__(52)
  , forOf              = __webpack_require__(53)
  , speciesConstructor = __webpack_require__(61)
  , task               = __webpack_require__(25).set
  , microtask          = __webpack_require__(58)()
  , PROMISE            = 'Promise'
  , TypeError          = global.TypeError
  , process            = global.process
  , $Promise           = global[PROMISE]
  , process            = global.process
  , isNode             = classof(process) == 'process'
  , empty              = function(){ /* empty */ }
  , Internal, GenericPromiseCapability, Wrapper;

var USE_NATIVE = !!function(){
  try {
    // correct subclassing with @@species support
    var promise     = $Promise.resolve(1)
      , FakePromise = (promise.constructor = {})[__webpack_require__(3)('species')] = function(exec){ exec(empty, empty); };
    // unhandled rejections tracking support, NodeJS Promise without it fails @@species test
    return (isNode || typeof PromiseRejectionEvent == 'function') && promise.then(empty) instanceof FakePromise;
  } catch(e){ /* empty */ }
}();

// helpers
var sameConstructor = function(a, b){
  // with library wrapper special case
  return a === b || a === $Promise && b === Wrapper;
};
var isThenable = function(it){
  var then;
  return isObject(it) && typeof (then = it.then) == 'function' ? then : false;
};
var newPromiseCapability = function(C){
  return sameConstructor($Promise, C)
    ? new PromiseCapability(C)
    : new GenericPromiseCapability(C);
};
var PromiseCapability = GenericPromiseCapability = function(C){
  var resolve, reject;
  this.promise = new C(function($$resolve, $$reject){
    if(resolve !== undefined || reject !== undefined)throw TypeError('Bad Promise constructor');
    resolve = $$resolve;
    reject  = $$reject;
  });
  this.resolve = aFunction(resolve);
  this.reject  = aFunction(reject);
};
var perform = function(exec){
  try {
    exec();
  } catch(e){
    return {error: e};
  }
};
var notify = function(promise, isReject){
  if(promise._n)return;
  promise._n = true;
  var chain = promise._c;
  microtask(function(){
    var value = promise._v
      , ok    = promise._s == 1
      , i     = 0;
    var run = function(reaction){
      var handler = ok ? reaction.ok : reaction.fail
        , resolve = reaction.resolve
        , reject  = reaction.reject
        , domain  = reaction.domain
        , result, then;
      try {
        if(handler){
          if(!ok){
            if(promise._h == 2)onHandleUnhandled(promise);
            promise._h = 1;
          }
          if(handler === true)result = value;
          else {
            if(domain)domain.enter();
            result = handler(value);
            if(domain)domain.exit();
          }
          if(result === reaction.promise){
            reject(TypeError('Promise-chain cycle'));
          } else if(then = isThenable(result)){
            then.call(result, resolve, reject);
          } else resolve(result);
        } else reject(value);
      } catch(e){
        reject(e);
      }
    };
    while(chain.length > i)run(chain[i++]); // variable length - can't use forEach
    promise._c = [];
    promise._n = false;
    if(isReject && !promise._h)onUnhandled(promise);
  });
};
var onUnhandled = function(promise){
  task.call(global, function(){
    var value = promise._v
      , abrupt, handler, console;
    if(isUnhandled(promise)){
      abrupt = perform(function(){
        if(isNode){
          process.emit('unhandledRejection', value, promise);
        } else if(handler = global.onunhandledrejection){
          handler({promise: promise, reason: value});
        } else if((console = global.console) && console.error){
          console.error('Unhandled promise rejection', value);
        }
      });
      // Browsers should not trigger `rejectionHandled` event if it was handled here, NodeJS - should
      promise._h = isNode || isUnhandled(promise) ? 2 : 1;
    } promise._a = undefined;
    if(abrupt)throw abrupt.error;
  });
};
var isUnhandled = function(promise){
  if(promise._h == 1)return false;
  var chain = promise._a || promise._c
    , i     = 0
    , reaction;
  while(chain.length > i){
    reaction = chain[i++];
    if(reaction.fail || !isUnhandled(reaction.promise))return false;
  } return true;
};
var onHandleUnhandled = function(promise){
  task.call(global, function(){
    var handler;
    if(isNode){
      process.emit('rejectionHandled', promise);
    } else if(handler = global.onrejectionhandled){
      handler({promise: promise, reason: promise._v});
    }
  });
};
var $reject = function(value){
  var promise = this;
  if(promise._d)return;
  promise._d = true;
  promise = promise._w || promise; // unwrap
  promise._v = value;
  promise._s = 2;
  if(!promise._a)promise._a = promise._c.slice();
  notify(promise, true);
};
var $resolve = function(value){
  var promise = this
    , then;
  if(promise._d)return;
  promise._d = true;
  promise = promise._w || promise; // unwrap
  try {
    if(promise === value)throw TypeError("Promise can't be resolved itself");
    if(then = isThenable(value)){
      microtask(function(){
        var wrapper = {_w: promise, _d: false}; // wrap
        try {
          then.call(value, ctx($resolve, wrapper, 1), ctx($reject, wrapper, 1));
        } catch(e){
          $reject.call(wrapper, e);
        }
      });
    } else {
      promise._v = value;
      promise._s = 1;
      notify(promise, false);
    }
  } catch(e){
    $reject.call({_w: promise, _d: false}, e); // wrap
  }
};

// constructor polyfill
if(!USE_NATIVE){
  // 25.4.3.1 Promise(executor)
  $Promise = function Promise(executor){
    anInstance(this, $Promise, PROMISE, '_h');
    aFunction(executor);
    Internal.call(this);
    try {
      executor(ctx($resolve, this, 1), ctx($reject, this, 1));
    } catch(err){
      $reject.call(this, err);
    }
  };
  Internal = function Promise(executor){
    this._c = [];             // <- awaiting reactions
    this._a = undefined;      // <- checked in isUnhandled reactions
    this._s = 0;              // <- state
    this._d = false;          // <- done
    this._v = undefined;      // <- value
    this._h = 0;              // <- rejection state, 0 - default, 1 - handled, 2 - unhandled
    this._n = false;          // <- notify
  };
  Internal.prototype = __webpack_require__(59)($Promise.prototype, {
    // 25.4.5.3 Promise.prototype.then(onFulfilled, onRejected)
    then: function then(onFulfilled, onRejected){
      var reaction    = newPromiseCapability(speciesConstructor(this, $Promise));
      reaction.ok     = typeof onFulfilled == 'function' ? onFulfilled : true;
      reaction.fail   = typeof onRejected == 'function' && onRejected;
      reaction.domain = isNode ? process.domain : undefined;
      this._c.push(reaction);
      if(this._a)this._a.push(reaction);
      if(this._s)notify(this, false);
      return reaction.promise;
    },
    // 25.4.5.1 Promise.prototype.catch(onRejected)
    'catch': function(onRejected){
      return this.then(undefined, onRejected);
    }
  });
  PromiseCapability = function(){
    var promise  = new Internal;
    this.promise = promise;
    this.resolve = ctx($resolve, promise, 1);
    this.reject  = ctx($reject, promise, 1);
  };
}

$export($export.G + $export.W + $export.F * !USE_NATIVE, {Promise: $Promise});
__webpack_require__(75)($Promise, PROMISE);
__webpack_require__(60)(PROMISE);
Wrapper = __webpack_require__(12)[PROMISE];

// statics
$export($export.S + $export.F * !USE_NATIVE, PROMISE, {
  // 25.4.4.5 Promise.reject(r)
  reject: function reject(r){
    var capability = newPromiseCapability(this)
      , $$reject   = capability.reject;
    $$reject(r);
    return capability.promise;
  }
});
$export($export.S + $export.F * (LIBRARY || !USE_NATIVE), PROMISE, {
  // 25.4.4.6 Promise.resolve(x)
  resolve: function resolve(x){
    // instanceof instead of internal slot check because we should fix it without replacement native Promise core
    if(x instanceof $Promise && sameConstructor(x.constructor, this))return x;
    var capability = newPromiseCapability(this)
      , $$resolve  = capability.resolve;
    $$resolve(x);
    return capability.promise;
  }
});
$export($export.S + $export.F * !(USE_NATIVE && __webpack_require__(57)(function(iter){
  $Promise.all(iter)['catch'](empty);
})), PROMISE, {
  // 25.4.4.1 Promise.all(iterable)
  all: function all(iterable){
    var C          = this
      , capability = newPromiseCapability(C)
      , resolve    = capability.resolve
      , reject     = capability.reject;
    var abrupt = perform(function(){
      var values    = []
        , index     = 0
        , remaining = 1;
      forOf(iterable, false, function(promise){
        var $index        = index++
          , alreadyCalled = false;
        values.push(undefined);
        remaining++;
        C.resolve(promise).then(function(value){
          if(alreadyCalled)return;
          alreadyCalled  = true;
          values[$index] = value;
          --remaining || resolve(values);
        }, reject);
      });
      --remaining || resolve(values);
    });
    if(abrupt)reject(abrupt.error);
    return capability.promise;
  },
  // 25.4.4.4 Promise.race(iterable)
  race: function race(iterable){
    var C          = this
      , capability = newPromiseCapability(C)
      , reject     = capability.reject;
    var abrupt = perform(function(){
      forOf(iterable, false, function(promise){
        C.resolve(promise).then(capability.resolve, reject);
      });
    });
    if(abrupt)reject(abrupt.error);
    return capability.promise;
  }
});

/***/ }),

/***/ 631:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(345);


/***/ }),

/***/ 71:
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {// This method of obtaining a reference to the global object needs to be
// kept identical to the way it is obtained in runtime.js
var g =
  typeof global === "object" ? global :
  typeof window === "object" ? window :
  typeof self === "object" ? self : this;

// Use `getOwnPropertyNames` because not all browsers support calling
// `hasOwnProperty` on the global `self` object in a worker. See #183.
var hadRuntime = g.regeneratorRuntime &&
  Object.getOwnPropertyNames(g).indexOf("regeneratorRuntime") >= 0;

// Save the old regeneratorRuntime in case it needs to be restored later.
var oldRuntime = hadRuntime && g.regeneratorRuntime;

// Force reevalutation of runtime.js.
g.regeneratorRuntime = undefined;

module.exports = __webpack_require__(72);

if (hadRuntime) {
  // Restore the original runtime.
  g.regeneratorRuntime = oldRuntime;
} else {
  // Remove the global property added by runtime.js.
  try {
    delete g.regeneratorRuntime;
  } catch(e) {
    g.regeneratorRuntime = undefined;
  }
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(11)))

/***/ }),

/***/ 72:
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global, process) {/**
 * Copyright (c) 2014, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * https://raw.github.com/facebook/regenerator/master/LICENSE file. An
 * additional grant of patent rights can be found in the PATENTS file in
 * the same directory.
 */

!(function(global) {
  "use strict";

  var Op = Object.prototype;
  var hasOwn = Op.hasOwnProperty;
  var undefined; // More compressible than void 0.
  var $Symbol = typeof Symbol === "function" ? Symbol : {};
  var iteratorSymbol = $Symbol.iterator || "@@iterator";
  var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";

  var inModule = typeof module === "object";
  var runtime = global.regeneratorRuntime;
  if (runtime) {
    if (inModule) {
      // If regeneratorRuntime is defined globally and we're in a module,
      // make the exports object identical to regeneratorRuntime.
      module.exports = runtime;
    }
    // Don't bother evaluating the rest of this file if the runtime was
    // already defined globally.
    return;
  }

  // Define the runtime globally (as expected by generated code) as either
  // module.exports (if we're in a module) or a new, empty object.
  runtime = global.regeneratorRuntime = inModule ? module.exports : {};

  function wrap(innerFn, outerFn, self, tryLocsList) {
    // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
    var generator = Object.create(protoGenerator.prototype);
    var context = new Context(tryLocsList || []);

    // The ._invoke method unifies the implementations of the .next,
    // .throw, and .return methods.
    generator._invoke = makeInvokeMethod(innerFn, self, context);

    return generator;
  }
  runtime.wrap = wrap;

  // Try/catch helper to minimize deoptimizations. Returns a completion
  // record like context.tryEntries[i].completion. This interface could
  // have been (and was previously) designed to take a closure to be
  // invoked without arguments, but in all the cases we care about we
  // already have an existing method we want to call, so there's no need
  // to create a new function object. We can even get away with assuming
  // the method takes exactly one argument, since that happens to be true
  // in every case, so we don't have to touch the arguments object. The
  // only additional allocation required is the completion record, which
  // has a stable shape and so hopefully should be cheap to allocate.
  function tryCatch(fn, obj, arg) {
    try {
      return { type: "normal", arg: fn.call(obj, arg) };
    } catch (err) {
      return { type: "throw", arg: err };
    }
  }

  var GenStateSuspendedStart = "suspendedStart";
  var GenStateSuspendedYield = "suspendedYield";
  var GenStateExecuting = "executing";
  var GenStateCompleted = "completed";

  // Returning this object from the innerFn has the same effect as
  // breaking out of the dispatch switch statement.
  var ContinueSentinel = {};

  // Dummy constructor functions that we use as the .constructor and
  // .constructor.prototype properties for functions that return Generator
  // objects. For full spec compliance, you may wish to configure your
  // minifier not to mangle the names of these two functions.
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}

  // This is a polyfill for %IteratorPrototype% for environments that
  // don't natively support it.
  var IteratorPrototype = {};
  IteratorPrototype[iteratorSymbol] = function () {
    return this;
  };

  var getProto = Object.getPrototypeOf;
  var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
  if (NativeIteratorPrototype &&
      NativeIteratorPrototype !== Op &&
      hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
    // This environment has a native %IteratorPrototype%; use it instead
    // of the polyfill.
    IteratorPrototype = NativeIteratorPrototype;
  }

  var Gp = GeneratorFunctionPrototype.prototype =
    Generator.prototype = Object.create(IteratorPrototype);
  GeneratorFunction.prototype = Gp.constructor = GeneratorFunctionPrototype;
  GeneratorFunctionPrototype.constructor = GeneratorFunction;
  GeneratorFunctionPrototype[toStringTagSymbol] =
    GeneratorFunction.displayName = "GeneratorFunction";

  // Helper for defining the .next, .throw, and .return methods of the
  // Iterator interface in terms of a single ._invoke method.
  function defineIteratorMethods(prototype) {
    ["next", "throw", "return"].forEach(function(method) {
      prototype[method] = function(arg) {
        return this._invoke(method, arg);
      };
    });
  }

  runtime.isGeneratorFunction = function(genFun) {
    var ctor = typeof genFun === "function" && genFun.constructor;
    return ctor
      ? ctor === GeneratorFunction ||
        // For the native GeneratorFunction constructor, the best we can
        // do is to check its .name property.
        (ctor.displayName || ctor.name) === "GeneratorFunction"
      : false;
  };

  runtime.mark = function(genFun) {
    if (Object.setPrototypeOf) {
      Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
    } else {
      genFun.__proto__ = GeneratorFunctionPrototype;
      if (!(toStringTagSymbol in genFun)) {
        genFun[toStringTagSymbol] = "GeneratorFunction";
      }
    }
    genFun.prototype = Object.create(Gp);
    return genFun;
  };

  // Within the body of any async function, `await x` is transformed to
  // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
  // `hasOwn.call(value, "__await")` to determine if the yielded value is
  // meant to be awaited.
  runtime.awrap = function(arg) {
    return { __await: arg };
  };

  function AsyncIterator(generator) {
    function invoke(method, arg, resolve, reject) {
      var record = tryCatch(generator[method], generator, arg);
      if (record.type === "throw") {
        reject(record.arg);
      } else {
        var result = record.arg;
        var value = result.value;
        if (value &&
            typeof value === "object" &&
            hasOwn.call(value, "__await")) {
          return Promise.resolve(value.__await).then(function(value) {
            invoke("next", value, resolve, reject);
          }, function(err) {
            invoke("throw", err, resolve, reject);
          });
        }

        return Promise.resolve(value).then(function(unwrapped) {
          // When a yielded Promise is resolved, its final value becomes
          // the .value of the Promise<{value,done}> result for the
          // current iteration. If the Promise is rejected, however, the
          // result for this iteration will be rejected with the same
          // reason. Note that rejections of yielded Promises are not
          // thrown back into the generator function, as is the case
          // when an awaited Promise is rejected. This difference in
          // behavior between yield and await is important, because it
          // allows the consumer to decide what to do with the yielded
          // rejection (swallow it and continue, manually .throw it back
          // into the generator, abandon iteration, whatever). With
          // await, by contrast, there is no opportunity to examine the
          // rejection reason outside the generator function, so the
          // only option is to throw it from the await expression, and
          // let the generator function handle the exception.
          result.value = unwrapped;
          resolve(result);
        }, reject);
      }
    }

    if (typeof process === "object" && process.domain) {
      invoke = process.domain.bind(invoke);
    }

    var previousPromise;

    function enqueue(method, arg) {
      function callInvokeWithMethodAndArg() {
        return new Promise(function(resolve, reject) {
          invoke(method, arg, resolve, reject);
        });
      }

      return previousPromise =
        // If enqueue has been called before, then we want to wait until
        // all previous Promises have been resolved before calling invoke,
        // so that results are always delivered in the correct order. If
        // enqueue has not been called before, then it is important to
        // call invoke immediately, without waiting on a callback to fire,
        // so that the async generator function has the opportunity to do
        // any necessary setup in a predictable way. This predictability
        // is why the Promise constructor synchronously invokes its
        // executor callback, and why async functions synchronously
        // execute code before the first await. Since we implement simple
        // async functions in terms of async generators, it is especially
        // important to get this right, even though it requires care.
        previousPromise ? previousPromise.then(
          callInvokeWithMethodAndArg,
          // Avoid propagating failures to Promises returned by later
          // invocations of the iterator.
          callInvokeWithMethodAndArg
        ) : callInvokeWithMethodAndArg();
    }

    // Define the unified helper method that is used to implement .next,
    // .throw, and .return (see defineIteratorMethods).
    this._invoke = enqueue;
  }

  defineIteratorMethods(AsyncIterator.prototype);
  runtime.AsyncIterator = AsyncIterator;

  // Note that simple async functions are implemented on top of
  // AsyncIterator objects; they just return a Promise for the value of
  // the final result produced by the iterator.
  runtime.async = function(innerFn, outerFn, self, tryLocsList) {
    var iter = new AsyncIterator(
      wrap(innerFn, outerFn, self, tryLocsList)
    );

    return runtime.isGeneratorFunction(outerFn)
      ? iter // If outerFn is a generator, return the full iterator.
      : iter.next().then(function(result) {
          return result.done ? result.value : iter.next();
        });
  };

  function makeInvokeMethod(innerFn, self, context) {
    var state = GenStateSuspendedStart;

    return function invoke(method, arg) {
      if (state === GenStateExecuting) {
        throw new Error("Generator is already running");
      }

      if (state === GenStateCompleted) {
        if (method === "throw") {
          throw arg;
        }

        // Be forgiving, per 25.3.3.3.3 of the spec:
        // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
        return doneResult();
      }

      context.method = method;
      context.arg = arg;

      while (true) {
        var delegate = context.delegate;
        if (delegate) {
          var delegateResult = maybeInvokeDelegate(delegate, context);
          if (delegateResult) {
            if (delegateResult === ContinueSentinel) continue;
            return delegateResult;
          }
        }

        if (context.method === "next") {
          // Setting context._sent for legacy support of Babel's
          // function.sent implementation.
          context.sent = context._sent = context.arg;

        } else if (context.method === "throw") {
          if (state === GenStateSuspendedStart) {
            state = GenStateCompleted;
            throw context.arg;
          }

          context.dispatchException(context.arg);

        } else if (context.method === "return") {
          context.abrupt("return", context.arg);
        }

        state = GenStateExecuting;

        var record = tryCatch(innerFn, self, context);
        if (record.type === "normal") {
          // If an exception is thrown from innerFn, we leave state ===
          // GenStateExecuting and loop back for another invocation.
          state = context.done
            ? GenStateCompleted
            : GenStateSuspendedYield;

          if (record.arg === ContinueSentinel) {
            continue;
          }

          return {
            value: record.arg,
            done: context.done
          };

        } else if (record.type === "throw") {
          state = GenStateCompleted;
          // Dispatch the exception by looping back around to the
          // context.dispatchException(context.arg) call above.
          context.method = "throw";
          context.arg = record.arg;
        }
      }
    };
  }

  // Call delegate.iterator[context.method](context.arg) and handle the
  // result, either by returning a { value, done } result from the
  // delegate iterator, or by modifying context.method and context.arg,
  // setting context.delegate to null, and returning the ContinueSentinel.
  function maybeInvokeDelegate(delegate, context) {
    var method = delegate.iterator[context.method];
    if (method === undefined) {
      // A .throw or .return when the delegate iterator has no .throw
      // method always terminates the yield* loop.
      context.delegate = null;

      if (context.method === "throw") {
        if (delegate.iterator.return) {
          // If the delegate iterator has a return method, give it a
          // chance to clean up.
          context.method = "return";
          context.arg = undefined;
          maybeInvokeDelegate(delegate, context);

          if (context.method === "throw") {
            // If maybeInvokeDelegate(context) changed context.method from
            // "return" to "throw", let that override the TypeError below.
            return ContinueSentinel;
          }
        }

        context.method = "throw";
        context.arg = new TypeError(
          "The iterator does not provide a 'throw' method");
      }

      return ContinueSentinel;
    }

    var record = tryCatch(method, delegate.iterator, context.arg);

    if (record.type === "throw") {
      context.method = "throw";
      context.arg = record.arg;
      context.delegate = null;
      return ContinueSentinel;
    }

    var info = record.arg;

    if (! info) {
      context.method = "throw";
      context.arg = new TypeError("iterator result is not an object");
      context.delegate = null;
      return ContinueSentinel;
    }

    if (info.done) {
      // Assign the result of the finished delegate to the temporary
      // variable specified by delegate.resultName (see delegateYield).
      context[delegate.resultName] = info.value;

      // Resume execution at the desired location (see delegateYield).
      context.next = delegate.nextLoc;

      // If context.method was "throw" but the delegate handled the
      // exception, let the outer generator proceed normally. If
      // context.method was "next", forget context.arg since it has been
      // "consumed" by the delegate iterator. If context.method was
      // "return", allow the original .return call to continue in the
      // outer generator.
      if (context.method !== "return") {
        context.method = "next";
        context.arg = undefined;
      }

    } else {
      // Re-yield the result returned by the delegate method.
      return info;
    }

    // The delegate iterator is finished, so forget it and continue with
    // the outer generator.
    context.delegate = null;
    return ContinueSentinel;
  }

  // Define Generator.prototype.{next,throw,return} in terms of the
  // unified ._invoke helper method.
  defineIteratorMethods(Gp);

  Gp[toStringTagSymbol] = "Generator";

  Gp.toString = function() {
    return "[object Generator]";
  };

  function pushTryEntry(locs) {
    var entry = { tryLoc: locs[0] };

    if (1 in locs) {
      entry.catchLoc = locs[1];
    }

    if (2 in locs) {
      entry.finallyLoc = locs[2];
      entry.afterLoc = locs[3];
    }

    this.tryEntries.push(entry);
  }

  function resetTryEntry(entry) {
    var record = entry.completion || {};
    record.type = "normal";
    delete record.arg;
    entry.completion = record;
  }

  function Context(tryLocsList) {
    // The root entry object (effectively a try statement without a catch
    // or a finally block) gives us a place to store values thrown from
    // locations where there is no enclosing try statement.
    this.tryEntries = [{ tryLoc: "root" }];
    tryLocsList.forEach(pushTryEntry, this);
    this.reset(true);
  }

  runtime.keys = function(object) {
    var keys = [];
    for (var key in object) {
      keys.push(key);
    }
    keys.reverse();

    // Rather than returning an object with a next method, we keep
    // things simple and return the next function itself.
    return function next() {
      while (keys.length) {
        var key = keys.pop();
        if (key in object) {
          next.value = key;
          next.done = false;
          return next;
        }
      }

      // To avoid creating an additional object, we just hang the .value
      // and .done properties off the next function object itself. This
      // also ensures that the minifier will not anonymize the function.
      next.done = true;
      return next;
    };
  };

  function values(iterable) {
    if (iterable) {
      var iteratorMethod = iterable[iteratorSymbol];
      if (iteratorMethod) {
        return iteratorMethod.call(iterable);
      }

      if (typeof iterable.next === "function") {
        return iterable;
      }

      if (!isNaN(iterable.length)) {
        var i = -1, next = function next() {
          while (++i < iterable.length) {
            if (hasOwn.call(iterable, i)) {
              next.value = iterable[i];
              next.done = false;
              return next;
            }
          }

          next.value = undefined;
          next.done = true;

          return next;
        };

        return next.next = next;
      }
    }

    // Return an iterator with no values.
    return { next: doneResult };
  }
  runtime.values = values;

  function doneResult() {
    return { value: undefined, done: true };
  }

  Context.prototype = {
    constructor: Context,

    reset: function(skipTempReset) {
      this.prev = 0;
      this.next = 0;
      // Resetting context._sent for legacy support of Babel's
      // function.sent implementation.
      this.sent = this._sent = undefined;
      this.done = false;
      this.delegate = null;

      this.method = "next";
      this.arg = undefined;

      this.tryEntries.forEach(resetTryEntry);

      if (!skipTempReset) {
        for (var name in this) {
          // Not sure about the optimal order of these conditions:
          if (name.charAt(0) === "t" &&
              hasOwn.call(this, name) &&
              !isNaN(+name.slice(1))) {
            this[name] = undefined;
          }
        }
      }
    },

    stop: function() {
      this.done = true;

      var rootEntry = this.tryEntries[0];
      var rootRecord = rootEntry.completion;
      if (rootRecord.type === "throw") {
        throw rootRecord.arg;
      }

      return this.rval;
    },

    dispatchException: function(exception) {
      if (this.done) {
        throw exception;
      }

      var context = this;
      function handle(loc, caught) {
        record.type = "throw";
        record.arg = exception;
        context.next = loc;

        if (caught) {
          // If the dispatched exception was caught by a catch block,
          // then let that catch block handle the exception normally.
          context.method = "next";
          context.arg = undefined;
        }

        return !! caught;
      }

      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        var record = entry.completion;

        if (entry.tryLoc === "root") {
          // Exception thrown outside of any try block that could handle
          // it, so set the completion value of the entire function to
          // throw the exception.
          return handle("end");
        }

        if (entry.tryLoc <= this.prev) {
          var hasCatch = hasOwn.call(entry, "catchLoc");
          var hasFinally = hasOwn.call(entry, "finallyLoc");

          if (hasCatch && hasFinally) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            } else if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else if (hasCatch) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            }

          } else if (hasFinally) {
            if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else {
            throw new Error("try statement without catch or finally");
          }
        }
      }
    },

    abrupt: function(type, arg) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc <= this.prev &&
            hasOwn.call(entry, "finallyLoc") &&
            this.prev < entry.finallyLoc) {
          var finallyEntry = entry;
          break;
        }
      }

      if (finallyEntry &&
          (type === "break" ||
           type === "continue") &&
          finallyEntry.tryLoc <= arg &&
          arg <= finallyEntry.finallyLoc) {
        // Ignore the finally entry if control is not jumping to a
        // location outside the try/catch block.
        finallyEntry = null;
      }

      var record = finallyEntry ? finallyEntry.completion : {};
      record.type = type;
      record.arg = arg;

      if (finallyEntry) {
        this.method = "next";
        this.next = finallyEntry.finallyLoc;
        return ContinueSentinel;
      }

      return this.complete(record);
    },

    complete: function(record, afterLoc) {
      if (record.type === "throw") {
        throw record.arg;
      }

      if (record.type === "break" ||
          record.type === "continue") {
        this.next = record.arg;
      } else if (record.type === "return") {
        this.rval = this.arg = record.arg;
        this.method = "return";
        this.next = "end";
      } else if (record.type === "normal" && afterLoc) {
        this.next = afterLoc;
      }

      return ContinueSentinel;
    },

    finish: function(finallyLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.finallyLoc === finallyLoc) {
          this.complete(entry.completion, entry.afterLoc);
          resetTryEntry(entry);
          return ContinueSentinel;
        }
      }
    },

    "catch": function(tryLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc === tryLoc) {
          var record = entry.completion;
          if (record.type === "throw") {
            var thrown = record.arg;
            resetTryEntry(entry);
          }
          return thrown;
        }
      }

      // The context.catch method must only be called with a location
      // argument that corresponds to a known catch block.
      throw new Error("illegal catch attempt");
    },

    delegateYield: function(iterable, resultName, nextLoc) {
      this.delegate = {
        iterator: values(iterable),
        resultName: resultName,
        nextLoc: nextLoc
      };

      if (this.method === "next") {
        // Deliberately forget the last sent value so that we don't
        // accidentally pass it on to the delegate.
        this.arg = undefined;
      }

      return ContinueSentinel;
    }
  };
})(
  // Among the various tricks for obtaining a reference to the global
  // object, this seems to be the most reliable technique that does not
  // use indirect eval (which violates Content Security Policy).
  typeof global === "object" ? global :
  typeof window === "object" ? window :
  typeof self === "object" ? self : this
);

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(11), __webpack_require__(18)))

/***/ }),

/***/ 79:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
/**
 * As the name suggests, creates a <button> object that can be added to uScope's toolbar.
 * When styling using this method, you should set the background image manually using CSS.
 * NOTE The styling should include ".us_rootstyle" to ensure eSM rules don't override
 *      styling on hover.
 * @param className (string) - name of class to attach to button. Useful for attaching images
 * @param title (string) - alt-text that will appear when user hovers over the icon
 * @param onClick (function) - callback to execute when the user clicks the button
 */
var createToolbarButton = exports.createToolbarButton = function createToolbarButton(_ref) {
    var className = _ref.className,
        title = _ref.title,
        onClick = _ref.onClick,
        _ref$context = _ref.context,
        context = _ref$context === undefined ? null : _ref$context;

    var button = document.createElement('button');
    button.className = 'uscope-toolbar-button ' + className;
    button.title = title;

    button.addEventListener('click', function (e) {
        for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
            args[_key - 1] = arguments[_key];
        }

        onClick.apply(context, [e].concat(args));
        e.preventDefault();
        e.stopImmediatePropagation();
        return false;
    });

    return button;
};

/***/ }),

/***/ 80:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.defaultSettings = exports.destinationInfo = exports.DESTINATIONS = exports.MAX_HEIGHT = exports.MAX_WIDTH = exports.modeInfo = exports.MODE_NAMES = exports.needsDimensions = exports.MODES = exports.SNAPSHOT_DRAW_BACKGROUND_COLOR = exports.ANIMATE_SPEED = exports.CSS_CLASS_NAMES = exports.DEFAULT_FILE_NAME = undefined;

var _defineProperty2 = __webpack_require__(159);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _needsDimensions, _MODE_NAMES, _modeInfo, _destinationInfo;

var _i18nEn = __webpack_require__(136);

var _i18nEn2 = _interopRequireDefault(_i18nEn);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DEFAULT_FILE_NAME = exports.DEFAULT_FILE_NAME = 'LeicaWebViewerSnapshot.jpg';

var CSS_CLASS_NAMES = exports.CSS_CLASS_NAMES = {
  MODE_BUTTONS: 'snapshot-mode-options',
  DESTINATION_BUTTONS: 'snapshot-destination-options',
  SIZE_OPTIONS: 'snapshot-size-options',
  DISABLED: 'snapshot-settings-disabled',
  VALIDATION_ERROR: 'lbs-validation-error',
  CANVAS_BASE_CLASS: 'us-snapshot-drawing-overlay'
};

var ANIMATE_SPEED = exports.ANIMATE_SPEED = {
  ASCENDING: 0.1,
  DESCENDING: -0.15
};

var SNAPSHOT_DRAW_BACKGROUND_COLOR = exports.SNAPSHOT_DRAW_BACKGROUND_COLOR = 'rgba(255, 255, 255, 0.6)';

/**
 * Drawable mode.
 */
var MODES = exports.MODES = {
  /**
   * WYSIWYG mode just captures what's on the current view.
   */
  WYSIWYG: 'wysiwyg',
  /**
   * Fixed mode captures a fixed-size area.
   */
  FIXED: 'fixed',
  /**
   * Allows the user to draw a rectangle on the viewport.
   */
  RESIZABLE: 'resizable',
  /**
   * Also allows the user to draw a rectangule on the viewport; aspect ratio is fixed.
   */
  FIXED_ASPECT: 'fixed-aspect'
};

/**
 * Lookup table defining whether the various modes require dimensions to be set.
 * @type {{}}
 */
var needsDimensions = exports.needsDimensions = (_needsDimensions = {}, (0, _defineProperty3.default)(_needsDimensions, MODES.WYSIWYG, false), (0, _defineProperty3.default)(_needsDimensions, MODES.FIXED, true), (0, _defineProperty3.default)(_needsDimensions, MODES.FIXED_ASPECT, true), (0, _defineProperty3.default)(_needsDimensions, MODES.RESIZABLE, false), _needsDimensions);

var MODE_NAMES = exports.MODE_NAMES = (_MODE_NAMES = {}, (0, _defineProperty3.default)(_MODE_NAMES, MODES.WYSIWYG, _i18nEn2.default['full-view']), (0, _defineProperty3.default)(_MODE_NAMES, MODES.FIXED, _i18nEn2.default['fixed-size']), (0, _defineProperty3.default)(_MODE_NAMES, MODES.RESIZABLE, _i18nEn2.default['resizable']), (0, _defineProperty3.default)(_MODE_NAMES, MODES.FIXED_ASPECT, _i18nEn2.default['fixed-aspect']), _MODE_NAMES);

/**
 * Text and words.
 */
var modeInfo = exports.modeInfo = (_modeInfo = {}, (0, _defineProperty3.default)(_modeInfo, MODES.WYSIWYG, _i18nEn2.default['full-view-description']), (0, _defineProperty3.default)(_modeInfo, MODES.FIXED, _i18nEn2.default['fixed-size-description']), (0, _defineProperty3.default)(_modeInfo, MODES.RESIZABLE, _i18nEn2.default['resizable-description']), (0, _defineProperty3.default)(_modeInfo, MODES.FIXED_ASPECT, _i18nEn2.default['fixed-aspect-description']), _modeInfo);

/**
 * The maximum width servable by image server
 * @type {number}
 */
var MAX_WIDTH = exports.MAX_WIDTH = 2000;
/**
 * The maximum height servable by image server
 * @type {number}
 */
var MAX_HEIGHT = exports.MAX_HEIGHT = 2000;

var DESTINATIONS = exports.DESTINATIONS = {
  CLIENT: 'client',
  SERVER: 'server'
};

var destinationInfo = exports.destinationInfo = (_destinationInfo = {}, (0, _defineProperty3.default)(_destinationInfo, DESTINATIONS.CLIENT, _i18nEn2.default['local-description']), (0, _defineProperty3.default)(_destinationInfo, DESTINATIONS.SERVER, _i18nEn2.default['remote-description']), _destinationInfo);

/**
 * Baseline settings.
 */
var defaultSettings = exports.defaultSettings = {
  /**
   * Capture mode: Whether or not to capture at the current resolution. No scaling will occur.
   */
  mode: MODES.WYSIWYG,
  /**
   * The height of the captured image.
   */
  height: 1600,
  /**
   * The width of the captured image.
   */
  width: 1600,

  destination: DESTINATIONS.CLIENT
};

/***/ }),

/***/ 9:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _promise = __webpack_require__(50);

var _promise2 = _interopRequireDefault(_promise);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (fn) {
  return function () {
    var gen = fn.apply(this, arguments);
    return new _promise2.default(function (resolve, reject) {
      function step(key, arg) {
        try {
          var info = gen[key](arg);
          var value = info.value;
        } catch (error) {
          reject(error);
          return;
        }

        if (info.done) {
          resolve(value);
        } else {
          return _promise2.default.resolve(value).then(function (value) {
            step("next", value);
          }, function (err) {
            step("throw", err);
          });
        }
      }

      return step("next");
    });
  };
};

/***/ })

},[631]);